var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloormapMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1379,
    height: 865,
    viewBox: "0 0 1379 865",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1357 244.212H196V275.212H1348.88V266.966L1357 274.379",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517 244.212V275.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 256.212H455",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 256.212H387",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 256.212H279",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 245.212V272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 256.212H319",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 257.212H520",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 256.327L330.578 267.212V258.32H319V253.146H330.578L330.911 245.212L341 256.327Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 635.84L233.937 646.212V637.702H245V632.808H233.937L233.619 625.212L224 635.84Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 636.212H258",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 636.212H275",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 636.212H303",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 636.212H313",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 636.212H321",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 636.212H328",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 636.212H338",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 636.212H354",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 636.212H376",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 636.212H209",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.72 636.971L1336.68 647.196V638.807H1347.78V633.982H1336.68L1336.36 626.493L1326.72 636.971Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.35 636.971L1111.34 647.196V638.807H1122.41V633.982H1111.34L1111 626.493L1101.35 636.971Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.35 636.863H1088.93",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.915 636.971L883.882 647.196V638.807H894.978V633.982H883.882L883.563 626.493L873.915 636.971Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.915 636.863H861.499",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.32 622.496V651.192",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.36 636.863H1257.95",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.84 622.496V651.192",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.9 636.863H1200.49",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.76 622.496V651.192",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.81 636.863H1144.39",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.48 259.342L1353.32 254.05V258.392H1347.57V260.889H1353.32L1353.48 264.765L1358.48 259.342Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.66 259.342L1254.49 254.05V258.392H1248.76V260.889H1254.49L1254.67 264.765L1259.66 259.342Z",
    stroke: "#3253DC",
    strokeWidth: 0.7007,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.33 259.417H1248.76",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.62 266.834V251.981",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.81 259.417H1336.23",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.87 266.834V251.981",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.07 259.417H1306.5",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.85 266.834V251.981",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.03 259.417H1277.46",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.03 622.496V651.192",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.08 636.863H1030.66",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.004 636.863H974.588",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.14 636.863H917.724",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 609.55L175.371 297.212H144V455.325V612.212",
    stroke: "#3253DC",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 244.212C196 244.212 167.033 249.249 156.447 263.216C146.637 276.224 144 297.212 144 297.212H175.586C175.586 297.212 178.279 288.041 181.109 282.862C183.94 277.682 196 274.141 196 274.141V244.212Z",
    stroke: "#3253DC",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 277.212L170 253.212",
    stroke: "#3253DC",
    strokeWidth: 0.7948,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 286.212L151 272.212",
    stroke: "#3253DC",
    strokeWidth: 0.8852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 436.212H176",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 442.212H176",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 551.284L176.449 551.142",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 556.095H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 560.057H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 565.01H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 569.963H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 573.926H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 578.879H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 583.832H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 588.785H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 593.738H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 598.691H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 499.774L176.449 499.631",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 504.584H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 508.547H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 513.5H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 518.453H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 522.415H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 527.368H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 532.321H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 537.274H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 542.227H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 547.18H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 448.262L176.449 448.119",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 453.073H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 457.035H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 461.988H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 466.941H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 470.903H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 475.856H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 480.809H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 485.762H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 490.715H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 495.668H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 384.864L176.449 384.722",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 389.675H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 393.638H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 398.591H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 403.544H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 407.506H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 412.459H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 417.412H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 422.365H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 427.318H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 432.271H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 333.353L176.449 333.21",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 338.163H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 342.126H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 347.079H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 352.032H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 355.994H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 360.947H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 365.9H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 370.853H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 375.806H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 380.759H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 300.521H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 304.483H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 309.436H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 314.389H176.075",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 319.342H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 324.295H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 329.248H176.449",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.759 609.588L176.449 609.093",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357 622.212H203V651.212H1357V622.212Z",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.414 625.602L176.715 609.212C176.715 609.212 179.583 616.497 185.399 619.425C191.214 622.353 203 622.201 203 622.201V651.202C203 651.202 187.686 651.991 167.953 639.35C155.469 631.316 144 611.944 144 611.944",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 640.212L185 619.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 649.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.873 212.212H481.127C479.39 212.212 478 210.667 478 208.737V205.687C478 203.756 479.39 202.212 481.127 202.212H483.873C485.61 202.212 487 203.756 487 205.687V208.737C487 210.667 485.575 212.212 483.873 212.212Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.915 631.212H255.085C253.927 631.212 253 630.285 253 629.127V627.297C253 626.139 253.927 625.212 255.085 625.212H256.915C258.073 625.212 259 626.139 259 627.297V629.127C259 630.285 258.05 631.212 256.915 631.212Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6439 459.217L58.6079 461.03C58.5851 462.177 57.6491 463.076 56.502 463.054L54.6894 463.018C53.5423 462.995 52.6427 462.059 52.6655 460.912L52.7015 459.099C52.7242 457.952 53.6602 457.052 54.8074 457.075L56.6199 457.111C57.7671 457.134 58.6662 458.093 58.6439 459.217Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.915 631.212H262.085C260.927 631.212 260 630.285 260 629.127V627.297C260 626.139 260.927 625.212 262.085 625.212H263.915C265.073 625.212 266 626.139 266 627.297V629.127C266 630.285 265.05 631.212 263.915 631.212Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7816 452.284L58.7456 454.097C58.7228 455.244 57.7868 456.144 56.6396 456.121L54.8271 456.085C53.6799 456.062 52.7804 455.126 52.8032 453.979L52.8392 452.166C52.8619 451.019 53.7979 450.12 54.9451 450.143L56.7576 450.178C57.9048 450.201 58.8039 451.16 58.7816 452.284Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.915 622.212H436.085C434.927 622.212 434 621.285 434 620.127V618.297C434 617.139 434.927 616.212 436.085 616.212H437.915C439.073 616.212 440 617.139 440 618.297V620.127C440 621.285 439.073 622.212 437.915 622.212Z",
    stroke: "#1593B0",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261 201.212H1026V398.212H1261V201.212Z",
    stroke: "#1593B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.969 651.692H820.289V701.213H852.969V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.969 651.692H820.289V668.523H852.969V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.064 656.645H831.186V660.598H843.064V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.006 677.448H824.251V693.288H849.006V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.629 700.223C845.106 700.223 851.978 693.35 851.978 684.873C851.978 676.396 845.106 669.523 836.629 669.523C828.152 669.523 821.279 676.396 821.279 684.873C821.279 693.35 828.152 700.223 836.629 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.969 702.213H820.289V751.734H852.969V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.969 702.213H820.289V719.044H852.969V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.064 707.166H831.186V711.119H843.064V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.006 727.968H824.251V743.808H849.006V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.629 750.743C845.106 750.743 851.978 743.87 851.978 735.393C851.978 726.916 845.106 720.043 836.629 720.043C828.152 720.043 821.279 726.916 821.279 735.393C821.279 743.87 828.152 750.743 836.629 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.75 651.692H971.071V701.213H1003.75V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.75 651.692H971.071V668.523H1003.75V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.845 656.645H981.967V660.598H993.845V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.788 677.448H975.033V693.288H999.788V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.411 700.223C995.888 700.223 1002.76 693.35 1002.76 684.873C1002.76 676.396 995.888 669.523 987.411 669.523C978.934 669.523 972.062 676.396 972.062 684.873C972.062 693.35 978.934 700.223 987.411 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.75 702.213H971.071V751.734H1003.75V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.75 702.213H971.071V719.044H1003.75V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.845 707.166H981.967V711.119H993.845V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.788 727.968H975.033V743.808H999.788V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.411 750.743C995.888 750.743 1002.76 743.87 1002.76 735.393C1002.76 726.916 995.888 720.043 987.411 720.043C978.934 720.043 972.062 726.916 972.062 735.393C972.062 743.87 978.934 750.743 987.411 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.53 651.692H1121.85V701.213H1154.53V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.53 651.692H1121.85V668.523H1154.53V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.63 656.645H1132.75V660.598H1144.63V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.57 677.448H1125.81V693.288H1150.57V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.19 700.223C1146.67 700.223 1153.54 693.35 1153.54 684.873C1153.54 676.396 1146.67 669.523 1138.19 669.523C1129.71 669.523 1122.84 676.396 1122.84 684.873C1122.84 693.35 1129.71 700.223 1138.19 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.53 702.213H1121.85V751.734H1154.53V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.53 702.213H1121.85V719.044H1154.53V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.63 707.166H1132.75V711.119H1144.63V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.57 727.968H1125.81V743.808H1150.57V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.19 750.743C1146.67 750.743 1153.54 743.87 1153.54 735.393C1153.54 726.916 1146.67 720.043 1138.19 720.043C1129.71 720.043 1122.84 726.916 1122.84 735.393C1122.84 743.87 1129.71 750.743 1138.19 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.31 651.692H1272.63V701.213H1305.31V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.31 651.692H1272.63V668.523H1305.31V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.41 656.645H1283.53V660.598H1295.41V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.36 677.448H1276.6V693.288H1301.36V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.97 700.223C1297.45 700.223 1304.32 693.35 1304.32 684.873C1304.32 676.396 1297.45 669.523 1288.97 669.523C1280.49 669.523 1273.62 676.396 1273.62 684.873C1273.62 693.35 1280.49 700.223 1288.97 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.31 702.213H1272.63V751.734H1305.31V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.31 702.213H1272.63V719.044H1305.31V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.41 707.166H1283.53V711.119H1295.41V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.36 727.968H1276.6V743.808H1301.36V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.97 750.743C1297.45 750.743 1304.32 743.87 1304.32 735.393C1304.32 726.916 1297.45 720.043 1288.97 720.043C1280.49 720.043 1273.62 726.916 1273.62 735.393C1273.62 743.87 1280.49 750.743 1288.97 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.494 651.692H895.814V701.213H928.494V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.494 651.692H895.814V668.523H928.494V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.589 656.645H906.711V660.598H918.589V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.532 677.448H899.777V693.288H924.532V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.155 700.223C920.632 700.223 927.505 693.35 927.505 684.873C927.505 676.396 920.632 669.523 912.155 669.523C903.678 669.523 896.805 676.396 896.805 684.873C896.805 693.35 903.678 700.223 912.155 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.494 702.213H895.814V751.734H928.494V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.494 702.213H895.814V719.044H928.494V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.589 707.166H906.711V711.119H918.589V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.532 727.968H899.777V743.808H924.532V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.155 750.743C920.632 750.743 927.505 743.87 927.505 735.393C927.505 726.916 920.632 720.043 912.155 720.043C903.678 720.043 896.805 726.916 896.805 735.393C896.805 743.87 903.678 750.743 912.155 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.28 651.692H1046.6V701.213H1079.28V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.28 651.692H1046.6V668.523H1079.28V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.37 656.645H1057.49V660.598H1069.37V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.32 677.448H1050.56V693.288H1075.32V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.94 700.223C1071.42 700.223 1078.29 693.35 1078.29 684.873C1078.29 676.396 1071.42 669.523 1062.94 669.523C1054.46 669.523 1047.59 676.396 1047.59 684.873C1047.59 693.35 1054.46 700.223 1062.94 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.28 702.213H1046.6V751.734H1079.28V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.28 702.213H1046.6V719.044H1079.28V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.37 707.166H1057.49V711.119H1069.37V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.32 727.968H1050.56V743.808H1075.32V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.94 750.743C1071.42 750.743 1078.29 743.87 1078.29 735.393C1078.29 726.916 1071.42 720.043 1062.94 720.043C1054.46 720.043 1047.59 726.916 1047.59 735.393C1047.59 743.87 1054.46 750.743 1062.94 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.06 651.692H1197.38V701.213H1230.06V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.06 651.692H1197.38V668.523H1230.06V651.692Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.15 656.645H1208.27V660.598H1220.15V656.645Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.1 677.448H1201.34V693.288H1226.1V677.448Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.72 700.223C1222.2 700.223 1229.07 693.35 1229.07 684.873C1229.07 676.396 1222.2 669.523 1213.72 669.523C1205.24 669.523 1198.37 676.396 1198.37 684.873C1198.37 693.35 1205.24 700.223 1213.72 700.223Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.06 702.213H1197.38V751.734H1230.06V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.06 702.213H1197.38V719.044H1230.06V702.213Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.15 707.166H1208.27V711.119H1220.15V707.166Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.1 727.968H1201.34V743.808H1226.1V727.968Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.72 750.743C1222.2 750.743 1229.07 743.87 1229.07 735.393C1229.07 726.916 1222.2 720.043 1213.72 720.043C1205.24 720.043 1198.37 726.916 1198.37 735.393C1198.37 743.87 1205.24 750.743 1213.72 750.743Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 682.712C866.038 682.712 868.5 680.249 868.5 677.212C868.5 674.174 866.038 671.712 863 671.712C859.962 671.712 857.5 674.174 857.5 677.212C857.5 680.249 859.962 682.712 863 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 732.712C866.038 732.712 868.5 730.249 868.5 727.212C868.5 724.174 866.038 721.712 863 721.712C859.962 721.712 857.5 724.174 857.5 727.212C857.5 730.249 859.962 732.712 863 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 682.712C1017.04 682.712 1019.5 680.249 1019.5 677.212C1019.5 674.174 1017.04 671.712 1014 671.712C1010.96 671.712 1008.5 674.174 1008.5 677.212C1008.5 680.249 1010.96 682.712 1014 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 732.712C1017.04 732.712 1019.5 730.249 1019.5 727.212C1019.5 724.174 1017.04 721.712 1014 721.712C1010.96 721.712 1008.5 724.174 1008.5 727.212C1008.5 730.249 1010.96 732.712 1014 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 682.712C1168.04 682.712 1170.5 680.249 1170.5 677.212C1170.5 674.174 1168.04 671.712 1165 671.712C1161.96 671.712 1159.5 674.174 1159.5 677.212C1159.5 680.249 1161.96 682.712 1165 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 732.712C1168.04 732.712 1170.5 730.249 1170.5 727.212C1170.5 724.174 1168.04 721.712 1165 721.712C1161.96 721.712 1159.5 724.174 1159.5 727.212C1159.5 730.249 1161.96 732.712 1165 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 682.712C1319.04 682.712 1321.5 680.249 1321.5 677.212C1321.5 674.174 1319.04 671.712 1316 671.712C1312.96 671.712 1310.5 674.174 1310.5 677.212C1310.5 680.249 1312.96 682.712 1316 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 732.712C1319.04 732.712 1321.5 730.249 1321.5 727.212C1321.5 724.174 1319.04 721.712 1316 721.712C1312.96 721.712 1310.5 724.174 1310.5 727.212C1310.5 730.249 1312.96 732.712 1316 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 682.712C942.038 682.712 944.5 680.249 944.5 677.212C944.5 674.174 942.038 671.712 939 671.712C935.962 671.712 933.5 674.174 933.5 677.212C933.5 680.249 935.962 682.712 939 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 732.712C942.038 732.712 944.5 730.249 944.5 727.212C944.5 724.174 942.038 721.712 939 721.712C935.962 721.712 933.5 724.174 933.5 727.212C933.5 730.249 935.962 732.712 939 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 682.712C1093.04 682.712 1095.5 680.249 1095.5 677.212C1095.5 674.174 1093.04 671.712 1090 671.712C1086.96 671.712 1084.5 674.174 1084.5 677.212C1084.5 680.249 1086.96 682.712 1090 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 732.712C1093.04 732.712 1095.5 730.249 1095.5 727.212C1095.5 724.174 1093.04 721.712 1090 721.712C1086.96 721.712 1084.5 724.174 1084.5 727.212C1084.5 730.249 1086.96 732.712 1090 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 677.212C1245.5 680.291 1243.22 682.712 1240.5 682.712C1237.78 682.712 1235.5 680.291 1235.5 677.212C1235.5 674.133 1237.78 671.712 1240.5 671.712C1243.22 671.712 1245.5 674.133 1245.5 677.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 727.212C1245.5 730.291 1243.22 732.712 1240.5 732.712C1237.78 732.712 1235.5 730.291 1235.5 727.212C1235.5 724.133 1237.78 721.712 1240.5 721.712C1243.22 721.712 1245.5 724.133 1245.5 727.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 668.712C866.038 668.712 868.5 666.249 868.5 663.212C868.5 660.174 866.038 657.712 863 657.712C859.962 657.712 857.5 660.174 857.5 663.212C857.5 666.249 859.962 668.712 863 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 718.712C866.038 718.712 868.5 716.249 868.5 713.212C868.5 710.174 866.038 707.712 863 707.712C859.962 707.712 857.5 710.174 857.5 713.212C857.5 716.249 859.962 718.712 863 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 668.712C1017.04 668.712 1019.5 666.249 1019.5 663.212C1019.5 660.174 1017.04 657.712 1014 657.712C1010.96 657.712 1008.5 660.174 1008.5 663.212C1008.5 666.249 1010.96 668.712 1014 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 718.712C1017.04 718.712 1019.5 716.249 1019.5 713.212C1019.5 710.174 1017.04 707.712 1014 707.712C1010.96 707.712 1008.5 710.174 1008.5 713.212C1008.5 716.249 1010.96 718.712 1014 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 668.712C1168.04 668.712 1170.5 666.249 1170.5 663.212C1170.5 660.174 1168.04 657.712 1165 657.712C1161.96 657.712 1159.5 660.174 1159.5 663.212C1159.5 666.249 1161.96 668.712 1165 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 718.712C1168.04 718.712 1170.5 716.249 1170.5 713.212C1170.5 710.174 1168.04 707.712 1165 707.712C1161.96 707.712 1159.5 710.174 1159.5 713.212C1159.5 716.249 1161.96 718.712 1165 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 668.712C1319.04 668.712 1321.5 666.249 1321.5 663.212C1321.5 660.174 1319.04 657.712 1316 657.712C1312.96 657.712 1310.5 660.174 1310.5 663.212C1310.5 666.249 1312.96 668.712 1316 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 718.712C1319.04 718.712 1321.5 716.249 1321.5 713.212C1321.5 710.174 1319.04 707.712 1316 707.712C1312.96 707.712 1310.5 710.174 1310.5 713.212C1310.5 716.249 1312.96 718.712 1316 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 668.712C942.038 668.712 944.5 666.249 944.5 663.212C944.5 660.174 942.038 657.712 939 657.712C935.962 657.712 933.5 660.174 933.5 663.212C933.5 666.249 935.962 668.712 939 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 718.712C942.038 718.712 944.5 716.249 944.5 713.212C944.5 710.174 942.038 707.712 939 707.712C935.962 707.712 933.5 710.174 933.5 713.212C933.5 716.249 935.962 718.712 939 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 668.712C1093.04 668.712 1095.5 666.249 1095.5 663.212C1095.5 660.174 1093.04 657.712 1090 657.712C1086.96 657.712 1084.5 660.174 1084.5 663.212C1084.5 666.249 1086.96 668.712 1090 668.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 718.712C1093.04 718.712 1095.5 716.249 1095.5 713.212C1095.5 710.174 1093.04 707.712 1090 707.712C1086.96 707.712 1084.5 710.174 1084.5 713.212C1084.5 716.249 1086.96 718.712 1090 718.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 663.212C1245.5 666.291 1243.22 668.712 1240.5 668.712C1237.78 668.712 1235.5 666.291 1235.5 663.212C1235.5 660.133 1237.78 657.712 1240.5 657.712C1243.22 657.712 1245.5 660.133 1245.5 663.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 713.212C1245.5 716.291 1243.22 718.712 1240.5 718.712C1237.78 718.712 1235.5 716.291 1235.5 713.212C1235.5 710.133 1237.78 707.712 1240.5 707.712C1243.22 707.712 1245.5 710.133 1245.5 713.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879 682.712C882.038 682.712 884.5 680.249 884.5 677.212C884.5 674.174 882.038 671.712 879 671.712C875.962 671.712 873.5 674.174 873.5 677.212C873.5 680.249 875.962 682.712 879 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879 732.712C882.038 732.712 884.5 730.249 884.5 727.212C884.5 724.174 882.038 721.712 879 721.712C875.962 721.712 873.5 724.174 873.5 727.212C873.5 730.249 875.962 732.712 879 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 682.712C1033.04 682.712 1035.5 680.249 1035.5 677.212C1035.5 674.174 1033.04 671.712 1030 671.712C1026.96 671.712 1024.5 674.174 1024.5 677.212C1024.5 680.249 1026.96 682.712 1030 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 732.712C1033.04 732.712 1035.5 730.249 1035.5 727.212C1035.5 724.174 1033.04 721.712 1030 721.712C1026.96 721.712 1024.5 724.174 1024.5 727.212C1024.5 730.249 1026.96 732.712 1030 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 682.712C1184.04 682.712 1186.5 680.249 1186.5 677.212C1186.5 674.174 1184.04 671.712 1181 671.712C1177.96 671.712 1175.5 674.174 1175.5 677.212C1175.5 680.249 1177.96 682.712 1181 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 732.712C1184.04 732.712 1186.5 730.249 1186.5 727.212C1186.5 724.174 1184.04 721.712 1181 721.712C1177.96 721.712 1175.5 724.174 1175.5 727.212C1175.5 730.249 1177.96 732.712 1181 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 682.712C1335.04 682.712 1337.5 680.249 1337.5 677.212C1337.5 674.174 1335.04 671.712 1332 671.712C1328.96 671.712 1326.5 674.174 1326.5 677.212C1326.5 680.249 1328.96 682.712 1332 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 732.712C1335.04 732.712 1337.5 730.249 1337.5 727.212C1337.5 724.174 1335.04 721.712 1332 721.712C1328.96 721.712 1326.5 724.174 1326.5 727.212C1326.5 730.249 1328.96 732.712 1332 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955 682.712C958.038 682.712 960.5 680.249 960.5 677.212C960.5 674.174 958.038 671.712 955 671.712C951.962 671.712 949.5 674.174 949.5 677.212C949.5 680.249 951.962 682.712 955 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955 732.712C958.038 732.712 960.5 730.249 960.5 727.212C960.5 724.174 958.038 721.712 955 721.712C951.962 721.712 949.5 724.174 949.5 727.212C949.5 730.249 951.962 732.712 955 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.5 677.212C1110.5 680.291 1108.22 682.712 1105.5 682.712C1102.78 682.712 1100.5 680.291 1100.5 677.212C1100.5 674.133 1102.78 671.712 1105.5 671.712C1108.22 671.712 1110.5 674.133 1110.5 677.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.5 727.212C1110.5 730.291 1108.22 732.712 1105.5 732.712C1102.78 732.712 1100.5 730.291 1100.5 727.212C1100.5 724.133 1102.78 721.712 1105.5 721.712C1108.22 721.712 1110.5 724.133 1110.5 727.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256 682.712C1259.04 682.712 1261.5 680.249 1261.5 677.212C1261.5 674.174 1259.04 671.712 1256 671.712C1252.96 671.712 1250.5 674.174 1250.5 677.212C1250.5 680.249 1252.96 682.712 1256 682.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256 732.712C1259.04 732.712 1261.5 730.249 1261.5 727.212C1261.5 724.174 1259.04 721.712 1256 721.712C1252.96 721.712 1250.5 724.174 1250.5 727.212C1250.5 730.249 1252.96 732.712 1256 732.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 696.712C866.038 696.712 868.5 694.249 868.5 691.212C868.5 688.174 866.038 685.712 863 685.712C859.962 685.712 857.5 688.174 857.5 691.212C857.5 694.249 859.962 696.712 863 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863 746.712C866.038 746.712 868.5 744.249 868.5 741.212C868.5 738.174 866.038 735.712 863 735.712C859.962 735.712 857.5 738.174 857.5 741.212C857.5 744.249 859.962 746.712 863 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 696.712C1017.04 696.712 1019.5 694.249 1019.5 691.212C1019.5 688.174 1017.04 685.712 1014 685.712C1010.96 685.712 1008.5 688.174 1008.5 691.212C1008.5 694.249 1010.96 696.712 1014 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014 746.712C1017.04 746.712 1019.5 744.249 1019.5 741.212C1019.5 738.174 1017.04 735.712 1014 735.712C1010.96 735.712 1008.5 738.174 1008.5 741.212C1008.5 744.249 1010.96 746.712 1014 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 696.712C1168.04 696.712 1170.5 694.249 1170.5 691.212C1170.5 688.174 1168.04 685.712 1165 685.712C1161.96 685.712 1159.5 688.174 1159.5 691.212C1159.5 694.249 1161.96 696.712 1165 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 746.712C1168.04 746.712 1170.5 744.249 1170.5 741.212C1170.5 738.174 1168.04 735.712 1165 735.712C1161.96 735.712 1159.5 738.174 1159.5 741.212C1159.5 744.249 1161.96 746.712 1165 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 696.712C1319.04 696.712 1321.5 694.249 1321.5 691.212C1321.5 688.174 1319.04 685.712 1316 685.712C1312.96 685.712 1310.5 688.174 1310.5 691.212C1310.5 694.249 1312.96 696.712 1316 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316 746.712C1319.04 746.712 1321.5 744.249 1321.5 741.212C1321.5 738.174 1319.04 735.712 1316 735.712C1312.96 735.712 1310.5 738.174 1310.5 741.212C1310.5 744.249 1312.96 746.712 1316 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 696.712C942.038 696.712 944.5 694.249 944.5 691.212C944.5 688.174 942.038 685.712 939 685.712C935.962 685.712 933.5 688.174 933.5 691.212C933.5 694.249 935.962 696.712 939 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939 746.712C942.038 746.712 944.5 744.249 944.5 741.212C944.5 738.174 942.038 735.712 939 735.712C935.962 735.712 933.5 738.174 933.5 741.212C933.5 744.249 935.962 746.712 939 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 696.712C1093.04 696.712 1095.5 694.249 1095.5 691.212C1095.5 688.174 1093.04 685.712 1090 685.712C1086.96 685.712 1084.5 688.174 1084.5 691.212C1084.5 694.249 1086.96 696.712 1090 696.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090 746.712C1093.04 746.712 1095.5 744.249 1095.5 741.212C1095.5 738.174 1093.04 735.712 1090 735.712C1086.96 735.712 1084.5 738.174 1084.5 741.212C1084.5 744.249 1086.96 746.712 1090 746.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 691.212C1245.5 694.291 1243.22 696.712 1240.5 696.712C1237.78 696.712 1235.5 694.291 1235.5 691.212C1235.5 688.133 1237.78 685.712 1240.5 685.712C1243.22 685.712 1245.5 688.133 1245.5 691.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.5 741.212C1245.5 744.291 1243.22 746.712 1240.5 746.712C1237.78 746.712 1235.5 744.291 1235.5 741.212C1235.5 738.133 1237.78 735.712 1240.5 735.712C1243.22 735.712 1245.5 738.133 1245.5 741.212Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.659 621.474V617.735H531.819V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.66 621.474V617.735H559.82V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.66 621.474V617.735H587.821V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.781 621.474V617.735H616.941V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 598.419V601.534H509.919V600.788H511.659V599.788H509.919V598.419H508.919Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 598.419V601.534H537.92V600.788H539.66V599.788H537.92V598.419H536.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 598.419V601.534H565.92V600.788H567.66V599.788H565.92V598.419H564.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 598.419V601.534H595.041V600.788H596.781V599.788H595.041V598.419H594.041Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 592.187V595.303H509.919V594.556H511.659V593.556H509.919V592.187H508.919Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 592.187V595.303H537.92V594.556H539.66V593.556H537.92V592.187H536.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 592.187V595.303H565.92V594.556H567.66V593.556H565.92V592.187H564.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 592.187V595.303H595.041V594.556H596.781V593.556H595.041V592.187H594.041Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 605.897V609.012H509.919V608.266H511.659V607.266H509.919V605.897H508.919Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 605.897V609.012H537.92V608.266H539.66V607.266H537.92V605.897H536.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 605.897V609.012H565.92V608.266H567.66V607.266H565.92V605.897H564.92Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 605.897V609.012H595.041V608.266H596.781V607.266H595.041V605.897H594.041Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 598.419V601.534H531.879V600.788H530.139V599.788H531.879V598.419H532.879Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 598.419V601.534H559.88V600.788H558.14V599.788H559.88V598.419H560.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 598.419V601.534H587.88V600.788H586.14V599.788H587.88V598.419H588.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 598.419V601.534H617.002V600.788H615.262V599.788H617.002V598.419H618.002Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 592.187V595.303H531.879V594.556H530.139V593.556H531.879V592.187H532.879Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 592.187V595.303H559.88V594.556H558.14V593.556H559.88V592.187H560.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 592.187V595.303H587.88V594.556H586.14V593.556H587.88V592.187H588.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 592.187V595.303H617.002V594.556H615.262V593.556H617.002V592.187H618.002Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 605.897V609.012H531.879V608.266H530.139V607.266H531.879V605.897H532.879Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 605.897V609.012H559.88V608.266H558.14V607.266H559.88V605.897H560.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 605.897V609.012H587.88V608.266H586.14V607.266H587.88V605.897H588.88Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 605.897V609.012H617.002V608.266H615.262V607.266H617.002V605.897H618.002Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.299 582.841V585.333H533.5V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3 582.841V585.333H561.5V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 582.841V585.333H589.501V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.421 582.841V585.333H618.622V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 618.358V615.866H534.06V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 618.358V615.866H562.06V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 618.358V615.866H590.061V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 618.358V615.866H619.182V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 587.826H511.659V612.75H509.419",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 587.826H539.66V612.75H537.42",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 587.826H567.661V612.75H565.421",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 587.826H596.781V612.75H594.541",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94 588.449H530.14V613.373H532.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 588.449H558.14V613.373H560.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.941 588.449H586.141V613.373H588.381",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.062 588.449H615.262V613.373H617.502",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 599.665V589.072H527.9V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 599.665V589.072H555.9V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 599.665V589.072H583.901V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 599.665V589.072H613.021V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 613.996V603.403H527.9V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 613.996V603.403H555.9V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 613.996V603.403H583.901V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 613.996V603.403H613.021V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.659 586.58V582.842H531.819V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.66 586.58V582.842H559.82V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.66 586.58V582.842H587.821V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.781 586.58V582.842H616.941V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 563.525V566.641H509.919V565.894H511.659V564.894H509.919V563.525H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 563.525V566.641H537.92V565.894H539.66V564.894H537.92V563.525H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 563.525V566.641H565.92V565.894H567.66V564.894H565.92V563.525H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 563.525V566.641H595.041V565.894H596.781V564.894H595.041V563.525H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 557.294V560.409H509.919V559.663H511.659V558.663H509.919V557.294H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 557.294V560.409H537.92V559.663H539.66V558.663H537.92V557.294H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 557.294V560.409H565.92V559.663H567.66V558.663H565.92V557.294H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 557.294V560.409H595.041V559.663H596.781V558.663H595.041V557.294H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 571.002V574.118H509.919V573.371H511.659V572.371H509.919V571.002H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 571.002V574.118H537.92V573.371H539.66V572.371H537.92V571.002H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 571.002V574.118H565.92V573.371H567.66V572.371H565.92V571.002H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 571.002V574.118H595.041V573.371H596.781V572.371H595.041V571.002H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 563.525V566.641H531.879V565.894H530.139V564.894H531.879V563.525H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 563.525V566.641H559.88V565.894H558.14V564.894H559.88V563.525H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 563.525V566.641H587.88V565.894H586.14V564.894H587.88V563.525H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 563.525V566.641H617.002V565.894H615.262V564.894H617.002V563.525H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 557.294V560.409H531.879V559.663H530.139V558.663H531.879V557.294H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 557.294V560.409H559.88V559.663H558.14V558.663H559.88V557.294H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 557.294V560.409H587.88V559.663H586.14V558.663H587.88V557.294H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 557.294V560.409H617.002V559.663H615.262V558.663H617.002V557.294H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 571.002V574.118H531.879V573.371H530.139V572.371H531.879V571.002H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 571.002V574.118H559.88V573.371H558.14V572.371H559.88V571.002H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 571.002V574.118H587.88V573.371H586.14V572.371H587.88V571.002H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 571.002V574.118H617.002V573.371H615.262V572.371H617.002V571.002H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.299 547.947V550.44H533.5V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3 547.947V550.44H561.5V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 547.947V550.44H589.501V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.421 547.947V550.44H618.622V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 583.465V580.972H534.06V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 583.465V580.972H562.06V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 583.465V580.972H590.061V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 583.465V580.972H619.182V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 552.932H511.659V577.857H509.419",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 552.932H539.66V577.857H537.42",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 552.932H567.661V577.857H565.421",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 552.932H596.781V577.857H594.541",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94 553.555H530.14V578.48H532.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 553.555H558.14V578.48H560.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.941 553.555H586.141V578.48H588.381",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.062 553.555H615.262V578.48H617.502",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 564.771V554.178H527.9V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 564.771V554.178H555.9V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 564.771V554.178H583.901V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 564.771V554.178H613.021V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 579.103V568.51H527.9V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 579.103V568.51H555.9V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 579.103V568.51H583.901V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 579.103V568.51H613.021V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.659 551.685V547.946H531.819V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.66 551.685V547.946H559.82V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.66 551.685V547.946H587.821V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.781 551.685V547.946H616.941V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 528.63V531.745H509.919V530.999H511.659V529.999H509.919V528.63H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 528.63V531.745H537.92V530.999H539.66V529.999H537.92V528.63H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 528.63V531.745H565.92V530.999H567.66V529.999H565.92V528.63H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 528.63V531.745H595.041V530.999H596.781V529.999H595.041V528.63H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 522.398V525.514H509.919V524.767H511.659V523.767H509.919V522.398H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 522.398V525.514H537.92V524.767H539.66V523.767H537.92V522.398H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 522.398V525.514H565.92V524.767H567.66V523.767H565.92V522.398H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 522.398V525.514H595.041V524.767H596.781V523.767H595.041V522.398H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 536.107V539.223H509.919V538.476H511.659V537.476H509.919V536.107H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 536.107V539.223H537.92V538.476H539.66V537.476H537.92V536.107H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 536.107V539.223H565.92V538.476H567.66V537.476H565.92V536.107H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 536.107V539.223H595.041V538.476H596.781V537.476H595.041V536.107H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 528.63V531.745H531.879V530.999H530.139V529.999H531.879V528.63H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 528.63V531.745H559.88V530.999H558.14V529.999H559.88V528.63H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 528.63V531.745H587.88V530.999H586.14V529.999H587.88V528.63H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 528.63V531.745H617.002V530.999H615.262V529.999H617.002V528.63H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 522.398V525.514H531.879V524.767H530.139V523.767H531.879V522.398H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 522.398V525.514H559.88V524.767H558.14V523.767H559.88V522.398H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 522.398V525.514H587.88V524.767H586.14V523.767H587.88V522.398H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 522.398V525.514H617.002V524.767H615.262V523.767H617.002V522.398H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 536.107V539.223H531.879V538.476H530.139V537.476H531.879V536.107H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 536.107V539.223H559.88V538.476H558.14V537.476H559.88V536.107H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 536.107V539.223H587.88V538.476H586.14V537.476H587.88V536.107H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 536.107V539.223H617.002V538.476H615.262V537.476H617.002V536.107H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.299 513.052V515.544H533.5V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3 513.052V515.544H561.5V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 513.052V515.544H589.501V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.421 513.052V515.544H618.622V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 548.569V546.077H534.06V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 548.569V546.077H562.06V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 548.569V546.077H590.061V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 548.569V546.077H619.182V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 518.037H511.659V542.961H509.419",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 518.037H539.66V542.961H537.42",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 518.037H567.661V542.961H565.421",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 518.037H596.781V542.961H594.541",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94 518.66H530.14V543.584H532.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 518.66H558.14V543.584H560.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.941 518.66H586.141V543.584H588.381",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.062 518.66H615.262V543.584H617.502",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 529.876V519.283H527.9V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 529.876V519.283H555.9V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 529.876V519.283H583.901V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 529.876V519.283H613.021V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 544.207V533.614H527.9V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 544.207V533.614H555.9V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 544.207V533.614H583.901V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 544.207V533.614H613.021V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.659 516.79V513.052H531.819V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.66 516.79V513.052H559.82V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.66 516.79V513.052H587.821V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.781 516.79V513.052H616.941V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 493.734V496.85H509.919V496.103H511.659V495.103H509.919V493.734H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 493.734V496.85H537.92V496.103H539.66V495.103H537.92V493.734H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 493.734V496.85H565.92V496.103H567.66V495.103H565.92V493.734H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 493.734V496.85H595.041V496.103H596.781V495.103H595.041V493.734H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 487.504V490.62H509.919V489.873H511.659V488.873H509.919V487.504H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 487.504V490.62H537.92V489.873H539.66V488.873H537.92V487.504H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 487.504V490.62H565.92V489.873H567.66V488.873H565.92V487.504H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 487.504V490.62H595.041V489.873H596.781V488.873H595.041V487.504H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 501.213V504.328H509.919V503.582H511.659V502.582H509.919V501.213H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 501.213V504.328H537.92V503.582H539.66V502.582H537.92V501.213H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 501.213V504.328H565.92V503.582H567.66V502.582H565.92V501.213H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 501.213V504.328H595.041V503.582H596.781V502.582H595.041V501.213H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 493.734V496.85H531.879V496.103H530.139V495.103H531.879V493.734H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 493.734V496.85H559.88V496.103H558.14V495.103H559.88V493.734H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 493.734V496.85H587.88V496.103H586.14V495.103H587.88V493.734H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 493.734V496.85H617.002V496.103H615.262V495.103H617.002V493.734H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 487.504V490.62H531.879V489.873H530.139V488.873H531.879V487.504H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 487.504V490.62H559.88V489.873H558.14V488.873H559.88V487.504H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 487.504V490.62H587.88V489.873H586.14V488.873H587.88V487.504H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 487.504V490.62H617.002V489.873H615.262V488.873H617.002V487.504H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 501.213V504.328H531.879V503.582H530.139V502.582H531.879V501.213H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 501.213V504.328H559.88V503.582H558.14V502.582H559.88V501.213H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 501.213V504.328H587.88V503.582H586.14V502.582H587.88V501.213H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 501.213V504.328H617.002V503.582H615.262V502.582H617.002V501.213H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.299 478.157V480.65H533.5V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3 478.157V480.65H561.5V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 478.157V480.65H589.501V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.421 478.157V480.65H618.622V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 513.675V511.182H534.06V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 513.675V511.182H562.06V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 513.675V511.182H590.061V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 513.675V511.182H619.182V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 483.142H511.659V508.067H509.419",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 483.142H539.66V508.067H537.42",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 483.142H567.661V508.067H565.421",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 483.142H596.781V508.067H594.541",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94 483.765H530.14V508.69H532.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 483.765H558.14V508.69H560.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.941 483.765H586.141V508.69H588.381",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.062 483.765H615.262V508.69H617.502",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 494.981V484.388H527.9V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 494.981V484.388H555.9V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 494.981V484.388H583.901V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 494.981V484.388H613.021V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 509.313V498.72H527.9V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 509.313V498.72H555.9V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 509.313V498.72H583.901V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 509.313V498.72H613.021V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.659 481.896V478.157H531.819V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.66 481.896V478.157H559.82V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.66 481.896V478.157H587.821V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.781 481.896V478.157H616.941V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 458.84V461.956H509.919V461.209H511.659V460.209H509.919V458.84H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 458.84V461.956H537.92V461.209H539.66V460.209H537.92V458.84H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 458.84V461.956H565.92V461.209H567.66V460.209H565.92V458.84H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 458.84V461.956H595.041V461.209H596.781V460.209H595.041V458.84H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 452.61V455.725H509.919V454.979H511.659V453.979H509.919V452.61H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 452.61V455.725H537.92V454.979H539.66V453.979H537.92V452.61H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 452.61V455.725H565.92V454.979H567.66V453.979H565.92V452.61H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 452.61V455.725H595.041V454.979H596.781V453.979H595.041V452.61H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.919 466.318V469.434H509.919V468.687H511.659V467.687H509.919V466.318H508.919Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.92 466.318V469.434H537.92V468.687H539.66V467.687H537.92V466.318H536.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.92 466.318V469.434H565.92V468.687H567.66V467.687H565.92V466.318H564.92Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.041 466.318V469.434H595.041V468.687H596.781V467.687H595.041V466.318H594.041Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 458.84V461.956H531.879V461.209H530.139V460.209H531.879V458.84H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 458.84V461.956H559.88V461.209H558.14V460.209H559.88V458.84H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 458.84V461.956H587.88V461.209H586.14V460.209H587.88V458.84H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 458.84V461.956H617.002V461.209H615.262V460.209H617.002V458.84H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 452.61V455.725H531.879V454.979H530.139V453.979H531.879V452.61H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 452.61V455.725H559.88V454.979H558.14V453.979H559.88V452.61H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 452.61V455.725H587.88V454.979H586.14V453.979H587.88V452.61H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 452.61V455.725H617.002V454.979H615.262V453.979H617.002V452.61H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.879 466.318V469.434H531.879V468.687H530.139V467.687H531.879V466.318H532.879Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.88 466.318V469.434H559.88V468.687H558.14V467.687H559.88V466.318H560.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M588.88 466.318V469.434H587.88V468.687H586.14V467.687H587.88V466.318H588.88Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.002 466.318V469.434H617.002V468.687H615.262V467.687H617.002V466.318H618.002Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.299 443.263V445.755H533.5V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.3 443.263V445.755H561.5V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.3 443.263V445.755H589.501V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.421 443.263V445.755H618.622V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 478.78V476.288H534.06V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 478.78V476.288H562.06V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 478.78V476.288H590.061V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 478.78V476.288H619.182V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.859 448.248H511.659V473.172H509.419",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.86 448.248H539.66V473.172H537.42",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.861 448.248H567.661V473.172H565.421",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.981 448.248H596.781V473.172H594.541",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.94 448.871H530.14V473.795H532.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.94 448.871H558.14V473.795H560.38",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.941 448.871H586.141V473.795H588.381",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.062 448.871H615.262V473.795H617.502",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 460.087V449.494H527.9V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 460.087V449.494H555.9V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 460.087V449.494H583.901V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 460.087V449.494H613.021V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.339 474.418V463.825H527.9V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34 474.418V463.825H555.9V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.341 474.418V463.825H583.901V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.461 474.418V463.825H613.021V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.9 621.474V617.735H1139.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.9 621.474V617.735H1167.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.9 621.474V617.735H1195.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.02 621.474V617.735H1224.18V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.16 598.419V601.534H1117.16V600.788H1118.9V599.788H1117.16V598.419H1116.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.16 598.419V601.534H1145.16V600.788H1146.9V599.788H1145.16V598.419H1144.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1172.16 598.419V601.534H1173.16V600.788H1174.9V599.788H1173.16V598.419H1172.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.28 598.419V601.534H1202.28V600.788H1204.02V599.788H1202.28V598.419H1201.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.16 592.187V595.303H1117.16V594.556H1118.9V593.556H1117.16V592.187H1116.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.16 592.187V595.303H1145.16V594.556H1146.9V593.556H1145.16V592.187H1144.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1172.16 592.187V595.303H1173.16V594.556H1174.9V593.556H1173.16V592.187H1172.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.28 592.187V595.303H1202.28V594.556H1204.02V593.556H1202.28V592.187H1201.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1116.16 605.897V609.012H1117.16V608.266H1118.9V607.266H1117.16V605.897H1116.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.16 605.897V609.012H1145.16V608.266H1146.9V607.266H1145.16V605.897H1144.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1172.16 605.897V609.012H1173.16V608.266H1174.9V607.266H1173.16V605.897H1172.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.28 605.897V609.012H1202.28V608.266H1204.02V607.266H1202.28V605.897H1201.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.12 598.419V601.534H1139.12V600.788H1137.38V599.788H1139.12V598.419H1140.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.12 598.419V601.534H1167.12V600.788H1165.38V599.788H1167.12V598.419H1168.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.12 598.419V601.534H1195.12V600.788H1193.38V599.788H1195.12V598.419H1196.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.24 598.419V601.534H1224.24V600.788H1222.5V599.788H1224.24V598.419H1225.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.12 592.187V595.303H1139.12V594.556H1137.38V593.556H1139.12V592.187H1140.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.12 592.187V595.303H1167.12V594.556H1165.38V593.556H1167.12V592.187H1168.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.12 592.187V595.303H1195.12V594.556H1193.38V593.556H1195.12V592.187H1196.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.24 592.187V595.303H1224.24V594.556H1222.5V593.556H1224.24V592.187H1225.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.12 605.897V609.012H1139.12V608.266H1137.38V607.266H1139.12V605.897H1140.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.12 605.897V609.012H1167.12V608.266H1165.38V607.266H1167.12V605.897H1168.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.12 605.897V609.012H1195.12V608.266H1193.38V607.266H1195.12V605.897H1196.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.24 605.897V609.012H1224.24V608.266H1222.5V607.266H1224.24V605.897H1225.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.54 582.841V585.333H1140.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.54 582.841V585.333H1168.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.54 582.841V585.333H1196.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.66 582.841V585.333H1225.86V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.1 618.358V615.866H1141.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.1 618.358V615.866H1169.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 618.358V615.866H1197.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.22 618.358V615.866H1226.42V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.1 587.826H1118.9V612.75H1116.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.1 587.826H1146.9V612.75H1144.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 587.826H1174.9V612.75H1172.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.22 587.826H1204.02V612.75H1201.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.18 588.449H1137.38V613.373H1139.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.18 588.449H1165.38V613.373H1167.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.18 588.449H1193.38V613.373H1195.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.3 588.449H1222.5V613.373H1224.74",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.58 599.665V589.072H1135.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.58 599.665V589.072H1163.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.58 599.665V589.072H1191.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.7 599.665V589.072H1220.26V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.58 613.996V603.403H1135.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.58 613.996V603.403H1163.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.58 613.996V603.403H1191.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.7 613.996V603.403H1220.26V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.058 621.474V617.735H842.218V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.059 621.474V617.735H870.219V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.059 621.474V617.735H898.219V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.18 621.474V617.735H927.34V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 598.419V601.534H820.318V600.788H822.058V599.788H820.318V598.419H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 598.419V601.534H848.319V600.788H850.059V599.788H848.319V598.419H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 598.419V601.534H876.319V600.788H878.059V599.788H876.319V598.419H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 598.419V601.534H905.44V600.788H907.18V599.788H905.44V598.419H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 592.187V595.303H820.318V594.556H822.058V593.556H820.318V592.187H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 592.187V595.303H848.319V594.556H850.059V593.556H848.319V592.187H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 592.187V595.303H876.319V594.556H878.059V593.556H876.319V592.187H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 592.187V595.303H905.44V594.556H907.18V593.556H905.44V592.187H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 605.897V609.012H820.318V608.266H822.058V607.266H820.318V605.897H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 605.897V609.012H848.319V608.266H850.059V607.266H848.319V605.897H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 605.897V609.012H876.319V608.266H878.059V607.266H876.319V605.897H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 605.897V609.012H905.44V608.266H907.18V607.266H905.44V605.897H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 598.419V601.534H842.278V600.788H840.538V599.788H842.278V598.419H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 598.419V601.534H870.279V600.788H868.539V599.788H870.279V598.419H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 598.419V601.534H898.279V600.788H896.539V599.788H898.279V598.419H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 598.419V601.534H927.4V600.788H925.66V599.788H927.4V598.419H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 592.187V595.303H842.278V594.556H840.538V593.556H842.278V592.187H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 592.187V595.303H870.279V594.556H868.539V593.556H870.279V592.187H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 592.187V595.303H898.279V594.556H896.539V593.556H898.279V592.187H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 592.187V595.303H927.4V594.556H925.66V593.556H927.4V592.187H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 605.897V609.012H842.278V608.266H840.538V607.266H842.278V605.897H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 605.897V609.012H870.279V608.266H868.539V607.266H870.279V605.897H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 605.897V609.012H898.279V608.266H896.539V607.266H898.279V605.897H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 605.897V609.012H927.4V608.266H925.66V607.266H927.4V605.897H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.698 582.841V585.333H843.899V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.699 582.841V585.333H871.899V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.699 582.841V585.333H899.9V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.82 582.841V585.333H929.02V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.258 618.358V615.866H844.459V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.259 618.358V615.866H872.459V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.26 618.358V615.866H900.46V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.38 618.358V615.866H929.581V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.258 587.826H822.058V612.75H819.818",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.259 587.826H850.059V612.75H847.819",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.26 587.826H878.06V612.75H875.82",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.38 587.826H907.18V612.75H904.94",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.339 588.449H840.539V613.373H842.779",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.339 588.449H868.539V613.373H870.779",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.34 588.449H896.54V613.373H898.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.461 588.449H925.661V613.373H927.901",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.738 599.665V589.072H838.299V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.739 599.665V589.072H866.299V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.74 599.665V589.072H894.3V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.86 599.665V589.072H923.42V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.738 613.996V603.403H838.299V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.739 613.996V603.403H866.299V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.74 613.996V603.403H894.3V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.86 613.996V603.403H923.42V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.058 585.333V581.595H842.218V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.059 585.333V581.595H870.219V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.059 585.333V581.595H898.219V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.18 585.333V581.595H927.34V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 562.278V565.394H820.318V564.647H822.058V563.647H820.318V562.278H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 562.278V565.394H848.319V564.647H850.059V563.647H848.319V562.278H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 562.278V565.394H876.319V564.647H878.059V563.647H876.319V562.278H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 562.278V565.394H905.44V564.647H907.18V563.647H905.44V562.278H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 556.047V559.163H820.318V558.416H822.058V557.416H820.318V556.047H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 556.047V559.163H848.319V558.416H850.059V557.416H848.319V556.047H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 556.047V559.163H876.319V558.416H878.059V557.416H876.319V556.047H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 556.047V559.163H905.44V558.416H907.18V557.416H905.44V556.047H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M819.318 569.755V572.871H820.318V572.124H822.058V571.124H820.318V569.755H819.318Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.319 569.755V572.871H848.319V572.124H850.059V571.124H848.319V569.755H847.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M875.319 569.755V572.871H876.319V572.124H878.059V571.124H876.319V569.755H875.319Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.44 569.755V572.871H905.44V572.124H907.18V571.124H905.44V569.755H904.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 562.278V565.394H842.278V564.647H840.538V563.647H842.278V562.278H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 562.278V565.394H870.279V564.647H868.539V563.647H870.279V562.278H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 562.278V565.394H898.279V564.647H896.539V563.647H898.279V562.278H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 562.278V565.394H927.4V564.647H925.66V563.647H927.4V562.278H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 556.047V559.163H842.278V558.416H840.538V557.416H842.278V556.047H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 556.047V559.163H870.279V558.416H868.539V557.416H870.279V556.047H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 556.047V559.163H898.279V558.416H896.539V557.416H898.279V556.047H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 556.047V559.163H927.4V558.416H925.66V557.416H927.4V556.047H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.278 569.755V572.871H842.278V572.124H840.538V571.124H842.278V569.755H843.278Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.279 569.755V572.871H870.279V572.124H868.539V571.124H870.279V569.755H871.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.279 569.755V572.871H898.279V572.124H896.539V571.124H898.279V569.755H899.279Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.4 569.755V572.871H927.4V572.124H925.66V571.124H927.4V569.755H928.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.698 546.7V549.193H843.899V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.699 546.7V549.193H871.899V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.699 546.7V549.193H899.9V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.82 546.7V549.193H929.02V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.258 582.218V579.725H844.459V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.259 582.218V579.725H872.459V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.26 582.218V579.725H900.46V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.38 582.218V579.725H929.581V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.258 551.685H822.058V576.61H819.818",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.259 551.685H850.059V576.61H847.819",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.26 551.685H878.06V576.61H875.82",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.38 551.685H907.18V576.61H904.94",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.339 552.308H840.539V577.233H842.779",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.339 552.308H868.539V577.233H870.779",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.34 552.308H896.54V577.233H898.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.461 552.308H925.661V577.233H927.901",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.738 563.524V552.931H838.299V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.739 563.524V552.931H866.299V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.74 563.524V552.931H894.3V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.86 563.524V552.931H923.42V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.738 577.856V567.263H838.299V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.739 577.856V567.263H866.299V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.74 577.856V567.263H894.3V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.86 577.856V567.263H923.42V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.661 621.474V617.735H643.822V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.662 621.474V617.735H671.823V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.663 621.474V617.735H699.823V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.783 621.474V617.735H728.944V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 598.419V601.534H621.922V600.788H623.662V599.788H621.922V598.419H620.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 598.419V601.534H649.922V600.788H651.662V599.788H649.922V598.419H648.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 598.419V601.534H677.923V600.788H679.663V599.788H677.923V598.419H676.923Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 598.419V601.534H707.043V600.788H708.783V599.788H707.043V598.419H706.043Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 592.187V595.303H621.922V594.556H623.662V593.556H621.922V592.187H620.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 592.187V595.303H649.922V594.556H651.662V593.556H649.922V592.187H648.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 592.187V595.303H677.923V594.556H679.663V593.556H677.923V592.187H676.923Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 592.187V595.303H707.043V594.556H708.783V593.556H707.043V592.187H706.043Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 605.897V609.012H621.922V608.266H623.662V607.266H621.922V605.897H620.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 605.897V609.012H649.922V608.266H651.662V607.266H649.922V605.897H648.922Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 605.897V609.012H677.923V608.266H679.663V607.266H677.923V605.897H676.923Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 605.897V609.012H707.043V608.266H708.783V607.266H707.043V605.897H706.043Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 598.419V601.534H643.882V600.788H642.142V599.788H643.882V598.419H644.882Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 598.419V601.534H671.883V600.788H670.143V599.788H671.883V598.419H672.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 598.419V601.534H699.883V600.788H698.143V599.788H699.883V598.419H700.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 598.419V601.534H729.005V600.788H727.264V599.788H729.005V598.419H730.005Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 592.187V595.303H643.882V594.556H642.142V593.556H643.882V592.187H644.882Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 592.187V595.303H671.883V594.556H670.143V593.556H671.883V592.187H672.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 592.187V595.303H699.883V594.556H698.143V593.556H699.883V592.187H700.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 592.187V595.303H729.005V594.556H727.264V593.556H729.005V592.187H730.005Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 605.897V609.012H643.882V608.266H642.142V607.266H643.882V605.897H644.882Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 605.897V609.012H671.883V608.266H670.143V607.266H671.883V605.897H672.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 605.897V609.012H699.883V608.266H698.143V607.266H699.883V605.897H700.883Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 605.897V609.012H729.005V608.266H727.264V607.266H729.005V605.897H730.005Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.302 582.841V585.333H645.502V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.302 582.841V585.333H673.503V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.303 582.841V585.333H701.503V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.423 582.841V585.333H730.624V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 618.358V615.866H646.062V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 618.358V615.866H674.063V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 618.358V615.866H702.064V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 618.358V615.866H731.184V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 587.826H623.662V612.75H621.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 587.826H651.662V612.75H649.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 587.826H679.663V612.75H677.423",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 587.826H708.784V612.75H706.544",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.942 588.449H642.142V613.373H644.382",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.943 588.449H670.143V613.373H672.383",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.944 588.449H698.144V613.373H700.384",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.064 588.449H727.264V613.373H729.504",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 599.665V589.072H639.902V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 599.665V589.072H667.902V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 599.665V589.072H695.903V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 599.665V589.072H725.024V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 613.996V603.403H639.902V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 613.996V603.403H667.902V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 613.996V603.403H695.903V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 613.996V603.403H725.024V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.6 621.474V617.735H1131.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.6 621.474V617.735H1159.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.6 621.474V617.735H1187.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.72 621.474V617.735H1216.88V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.86 598.419V601.534H1109.86V600.788H1111.6V599.788H1109.86V598.419H1108.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136.86 598.419V601.534H1137.86V600.788H1139.6V599.788H1137.86V598.419H1136.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164.86 598.419V601.534H1165.86V600.788H1167.6V599.788H1165.86V598.419H1164.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1193.98 598.419V601.534H1194.98V600.788H1196.72V599.788H1194.98V598.419H1193.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.86 592.187V595.303H1109.86V594.556H1111.6V593.556H1109.86V592.187H1108.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136.86 592.187V595.303H1137.86V594.556H1139.6V593.556H1137.86V592.187H1136.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164.86 592.187V595.303H1165.86V594.556H1167.6V593.556H1165.86V592.187H1164.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1193.98 592.187V595.303H1194.98V594.556H1196.72V593.556H1194.98V592.187H1193.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.86 605.897V609.012H1109.86V608.266H1111.6V607.266H1109.86V605.897H1108.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136.86 605.897V609.012H1137.86V608.266H1139.6V607.266H1137.86V605.897H1136.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164.86 605.897V609.012H1165.86V608.266H1167.6V607.266H1165.86V605.897H1164.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1193.98 605.897V609.012H1194.98V608.266H1196.72V607.266H1194.98V605.897H1193.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1132.82 598.419V601.534H1131.82V600.788H1130.08V599.788H1131.82V598.419H1132.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1160.82 598.419V601.534H1159.82V600.788H1158.08V599.788H1159.82V598.419H1160.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188.82 598.419V601.534H1187.82V600.788H1186.08V599.788H1187.82V598.419H1188.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.94 598.419V601.534H1216.94V600.788H1215.2V599.788H1216.94V598.419H1217.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1132.82 592.187V595.303H1131.82V594.556H1130.08V593.556H1131.82V592.187H1132.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1160.82 592.187V595.303H1159.82V594.556H1158.08V593.556H1159.82V592.187H1160.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188.82 592.187V595.303H1187.82V594.556H1186.08V593.556H1187.82V592.187H1188.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.94 592.187V595.303H1216.94V594.556H1215.2V593.556H1216.94V592.187H1217.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1132.82 605.897V609.012H1131.82V608.266H1130.08V607.266H1131.82V605.897H1132.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1160.82 605.897V609.012H1159.82V608.266H1158.08V607.266H1159.82V605.897H1160.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188.82 605.897V609.012H1187.82V608.266H1186.08V607.266H1187.82V605.897H1188.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.94 605.897V609.012H1216.94V608.266H1215.2V607.266H1216.94V605.897H1217.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.24 582.841V585.333H1133.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.24 582.841V585.333H1161.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.24 582.841V585.333H1189.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.36 582.841V585.333H1218.56V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.8 618.358V615.866H1134V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.8 618.358V615.866H1162V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.8 618.358V615.866H1190V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.92 618.358V615.866H1219.12V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.8 587.826H1111.6V612.75H1109.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.8 587.826H1139.6V612.75H1137.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.8 587.826H1167.6V612.75H1165.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.92 587.826H1196.72V612.75H1194.48",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.88 588.449H1130.08V613.373H1132.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.88 588.449H1158.08V613.373H1160.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.88 588.449H1186.08V613.373H1188.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218 588.449H1215.2V613.373H1217.44",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.28 599.665V589.072H1127.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.28 599.665V589.072H1155.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.28 599.665V589.072H1183.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.4 599.665V589.072H1212.96V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.28 613.996V603.403H1127.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.28 613.996V603.403H1155.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.28 613.996V603.403H1183.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.4 613.996V603.403H1212.96V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.92 590.012V586.634H1145.14V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.22 590.012V586.634H1170.44V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.52 590.012V586.634H1195.73V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.83 590.012V586.634H1222.04V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.4 569.182V571.997H1125.4V571.371H1126.92V570.371H1125.4V569.182H1124.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.7 569.182V571.997H1150.7V571.371H1152.22V570.371H1150.7V569.182H1149.7Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175 569.182V571.997H1176V571.371H1177.52V570.371H1176V569.182H1175Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.31 569.182V571.997H1202.31V571.371H1203.83V570.371H1202.31V569.182H1201.31Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.4 563.552V566.367H1125.4V565.741H1126.92V564.741H1125.4V563.552H1124.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.7 563.552V566.367H1150.7V565.741H1152.22V564.741H1150.7V563.552H1149.7Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175 563.552V566.367H1176V565.741H1177.52V564.741H1176V563.552H1175Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.31 563.552V566.367H1202.31V565.741H1203.83V564.741H1202.31V563.552H1201.31Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.4 575.937V578.752H1125.4V578.126H1126.92V577.126H1125.4V575.937H1124.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.7 575.937V578.752H1150.7V578.126H1152.22V577.126H1150.7V575.937H1149.7Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175 575.937V578.752H1176V578.126H1177.52V577.126H1176V575.937H1175Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1201.31 575.937V578.752H1202.31V578.126H1203.83V577.126H1202.31V575.937H1201.31Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.14 569.182V571.997H1145.14V571.371H1143.62V570.371H1145.14V569.182H1146.14Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.44 569.182V571.997H1170.44V571.371H1168.92V570.371H1170.44V569.182H1171.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.74 569.182V571.997H1195.74V571.371H1194.22V570.371H1195.74V569.182H1196.74Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.05 569.182V571.997H1222.05V571.371H1220.53V570.371H1222.05V569.182H1223.05Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.14 563.552V566.367H1145.14V565.741H1143.62V564.741H1145.14V563.552H1146.14Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.44 563.552V566.367H1170.44V565.741H1168.92V564.741H1170.44V563.552H1171.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.74 563.552V566.367H1195.74V565.741H1194.22V564.741H1195.74V563.552H1196.74Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.05 563.552V566.367H1222.05V565.741H1220.53V564.741H1222.05V563.552H1223.05Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.14 575.937V578.752H1145.14V578.126H1143.62V577.126H1145.14V575.937H1146.14Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.44 575.937V578.752H1170.44V578.126H1168.92V577.126H1170.44V575.937H1171.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.74 575.937V578.752H1195.74V578.126H1194.22V577.126H1195.74V575.937H1196.74Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.05 575.937V578.752H1222.05V578.126H1220.53V577.126H1222.05V575.937H1223.05Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.89 555.107V557.359H1146.66V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.19 555.107V557.359H1171.95V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.48 555.107V557.359H1197.25V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.79 555.107V557.359H1223.56V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.39 587.197V584.945H1147.16V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.69 587.197V584.945H1172.46V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 587.197V584.945H1197.76V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.3 587.197V584.945H1224.07V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.39 559.612H1126.92V582.131H1124.9",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.69 559.612H1152.22V582.131H1150.2",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 559.612H1177.52V582.131H1175.5",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.3 559.612H1203.83V582.131H1201.81",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.15 560.175H1143.62V582.694H1145.64",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.45 560.175H1168.92V582.694H1170.94",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.75 560.175H1194.22V582.694H1196.24",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.06 560.175H1220.53V582.694H1222.55",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.44 570.307V560.737H1141.6V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.74 570.307V560.737H1166.89V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.04 570.307V560.737H1192.19V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.35 570.307V560.737H1218.5V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.44 583.257V573.686H1141.6V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.74 583.257V573.686H1166.89V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.04 583.257V573.686H1192.19V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.35 583.257V573.686H1218.5V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.661 586.58V582.842H643.822V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.662 586.58V582.842H671.823V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.663 586.58V582.842H699.823V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.783 586.58V582.842H728.944V586.58",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 563.525V566.641H621.922V565.894H623.662V564.894H621.922V563.525H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 563.525V566.641H649.922V565.894H651.662V564.894H649.922V563.525H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 563.525V566.641H677.923V565.894H679.663V564.894H677.923V563.525H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 563.525V566.641H707.043V565.894H708.783V564.894H707.043V563.525H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 557.294V560.409H621.922V559.663H623.662V558.663H621.922V557.294H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 557.294V560.409H649.922V559.663H651.662V558.663H649.922V557.294H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 557.294V560.409H677.923V559.663H679.663V558.663H677.923V557.294H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 557.294V560.409H707.043V559.663H708.783V558.663H707.043V557.294H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 571.002V574.118H621.922V573.371H623.662V572.371H621.922V571.002H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 571.002V574.118H649.922V573.371H651.662V572.371H649.922V571.002H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 571.002V574.118H677.923V573.371H679.663V572.371H677.923V571.002H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 571.002V574.118H707.043V573.371H708.783V572.371H707.043V571.002H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 563.525V566.641H643.882V565.894H642.142V564.894H643.882V563.525H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 563.525V566.641H671.883V565.894H670.143V564.894H671.883V563.525H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 563.525V566.641H699.883V565.894H698.143V564.894H699.883V563.525H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 563.525V566.641H729.005V565.894H727.264V564.894H729.005V563.525H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 557.294V560.409H643.882V559.663H642.142V558.663H643.882V557.294H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 557.294V560.409H671.883V559.663H670.143V558.663H671.883V557.294H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 557.294V560.409H699.883V559.663H698.143V558.663H699.883V557.294H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 557.294V560.409H729.005V559.663H727.264V558.663H729.005V557.294H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 571.002V574.118H643.882V573.371H642.142V572.371H643.882V571.002H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 571.002V574.118H671.883V573.371H670.143V572.371H671.883V571.002H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 571.002V574.118H699.883V573.371H698.143V572.371H699.883V571.002H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 571.002V574.118H729.005V573.371H727.264V572.371H729.005V571.002H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.302 547.947V550.44H645.502V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.302 547.947V550.44H673.503V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.303 547.947V550.44H701.503V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.423 547.947V550.44H730.624V547.947",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 583.465V580.972H646.062V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 583.465V580.972H674.063V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 583.465V580.972H702.064V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 583.465V580.972H731.184V583.465",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 552.932H623.662V577.857H621.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 552.932H651.662V577.857H649.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 552.932H679.663V577.857H677.423",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 552.932H708.784V577.857H706.544",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.942 553.555H642.142V578.48H644.382",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.943 553.555H670.143V578.48H672.383",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.944 553.555H698.144V578.48H700.384",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.064 553.555H727.264V578.48H729.504",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 564.771V554.178H639.902V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 564.771V554.178H667.902V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 564.771V554.178H695.903V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 564.771V554.178H725.024V564.771",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 579.103V568.51H639.902V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 579.103V568.51H667.902V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 579.103V568.51H695.903V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 579.103V568.51H725.024V579.103",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.661 551.685V547.946H643.822V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.662 551.685V547.946H671.823V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.663 551.685V547.946H699.823V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.783 551.685V547.946H728.944V551.685",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 528.63V531.745H621.922V530.999H623.662V529.999H621.922V528.63H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 528.63V531.745H649.922V530.999H651.662V529.999H649.922V528.63H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 528.63V531.745H677.923V530.999H679.663V529.999H677.923V528.63H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 528.63V531.745H707.043V530.999H708.783V529.999H707.043V528.63H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 522.398V525.514H621.922V524.767H623.662V523.767H621.922V522.398H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 522.398V525.514H649.922V524.767H651.662V523.767H649.922V522.398H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 522.398V525.514H677.923V524.767H679.663V523.767H677.923V522.398H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 522.398V525.514H707.043V524.767H708.783V523.767H707.043V522.398H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 536.107V539.223H621.922V538.476H623.662V537.476H621.922V536.107H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 536.107V539.223H649.922V538.476H651.662V537.476H649.922V536.107H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 536.107V539.223H677.923V538.476H679.663V537.476H677.923V536.107H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 536.107V539.223H707.043V538.476H708.783V537.476H707.043V536.107H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 528.63V531.745H643.882V530.999H642.142V529.999H643.882V528.63H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 528.63V531.745H671.883V530.999H670.143V529.999H671.883V528.63H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 528.63V531.745H699.883V530.999H698.143V529.999H699.883V528.63H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 528.63V531.745H729.005V530.999H727.264V529.999H729.005V528.63H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 522.398V525.514H643.882V524.767H642.142V523.767H643.882V522.398H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 522.398V525.514H671.883V524.767H670.143V523.767H671.883V522.398H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 522.398V525.514H699.883V524.767H698.143V523.767H699.883V522.398H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 522.398V525.514H729.005V524.767H727.264V523.767H729.005V522.398H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 536.107V539.223H643.882V538.476H642.142V537.476H643.882V536.107H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 536.107V539.223H671.883V538.476H670.143V537.476H671.883V536.107H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 536.107V539.223H699.883V538.476H698.143V537.476H699.883V536.107H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 536.107V539.223H729.005V538.476H727.264V537.476H729.005V536.107H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.302 513.052V515.544H645.502V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.302 513.052V515.544H673.503V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.303 513.052V515.544H701.503V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.423 513.052V515.544H730.624V513.052",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 548.569V546.077H646.062V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 548.569V546.077H674.063V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 548.569V546.077H702.064V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 548.569V546.077H731.184V548.569",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 518.037H623.662V542.961H621.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 518.037H651.662V542.961H649.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 518.037H679.663V542.961H677.423",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 518.037H708.784V542.961H706.544",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.942 518.66H642.142V543.584H644.382",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.943 518.66H670.143V543.584H672.383",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.944 518.66H698.144V543.584H700.384",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.064 518.66H727.264V543.584H729.504",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 529.876V519.283H639.902V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 529.876V519.283H667.902V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 529.876V519.283H695.903V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 529.876V519.283H725.024V529.876",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 544.207V533.614H639.902V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 544.207V533.614H667.902V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 544.207V533.614H695.903V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 544.207V533.614H725.024V544.207",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.661 516.79V513.052H643.822V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.662 516.79V513.052H671.823V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.663 516.79V513.052H699.823V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.783 516.79V513.052H728.944V516.79",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 493.734V496.85H621.922V496.103H623.662V495.103H621.922V493.734H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 493.734V496.85H649.922V496.103H651.662V495.103H649.922V493.734H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 493.734V496.85H677.923V496.103H679.663V495.103H677.923V493.734H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 493.734V496.85H707.043V496.103H708.783V495.103H707.043V493.734H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 487.504V490.62H621.922V489.873H623.662V488.873H621.922V487.504H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 487.504V490.62H649.922V489.873H651.662V488.873H649.922V487.504H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 487.504V490.62H677.923V489.873H679.663V488.873H677.923V487.504H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 487.504V490.62H707.043V489.873H708.783V488.873H707.043V487.504H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 501.213V504.328H621.922V503.582H623.662V502.582H621.922V501.213H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 501.213V504.328H649.922V503.582H651.662V502.582H649.922V501.213H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 501.213V504.328H677.923V503.582H679.663V502.582H677.923V501.213H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 501.213V504.328H707.043V503.582H708.783V502.582H707.043V501.213H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 493.734V496.85H643.882V496.103H642.142V495.103H643.882V493.734H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 493.734V496.85H671.883V496.103H670.143V495.103H671.883V493.734H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 493.734V496.85H699.883V496.103H698.143V495.103H699.883V493.734H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 493.734V496.85H729.005V496.103H727.264V495.103H729.005V493.734H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 487.504V490.62H643.882V489.873H642.142V488.873H643.882V487.504H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 487.504V490.62H671.883V489.873H670.143V488.873H671.883V487.504H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 487.504V490.62H699.883V489.873H698.143V488.873H699.883V487.504H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 487.504V490.62H729.005V489.873H727.264V488.873H729.005V487.504H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 501.213V504.328H643.882V503.582H642.142V502.582H643.882V501.213H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 501.213V504.328H671.883V503.582H670.143V502.582H671.883V501.213H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 501.213V504.328H699.883V503.582H698.143V502.582H699.883V501.213H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 501.213V504.328H729.005V503.582H727.264V502.582H729.005V501.213H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.302 478.157V480.65H645.502V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.302 478.157V480.65H673.503V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.303 478.157V480.65H701.503V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.423 478.157V480.65H730.624V478.157",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 513.675V511.182H646.062V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 513.675V511.182H674.063V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 513.675V511.182H702.064V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 513.675V511.182H731.184V513.675",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 483.142H623.662V508.067H621.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 483.142H651.662V508.067H649.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 483.142H679.663V508.067H677.423",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 483.142H708.784V508.067H706.544",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.942 483.765H642.142V508.69H644.382",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.943 483.765H670.143V508.69H672.383",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.944 483.765H698.144V508.69H700.384",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.064 483.765H727.264V508.69H729.504",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 494.981V484.388H639.902V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 494.981V484.388H667.902V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 494.981V484.388H695.903V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 494.981V484.388H725.024V494.981",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 509.313V498.72H639.902V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 509.313V498.72H667.902V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 509.313V498.72H695.903V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 509.313V498.72H725.024V509.313",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.661 481.896V478.157H643.822V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.662 481.896V478.157H671.823V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.663 481.896V478.157H699.823V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.783 481.896V478.157H728.944V481.896",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 458.84V461.956H621.922V461.209H623.662V460.209H621.922V458.84H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 458.84V461.956H649.922V461.209H651.662V460.209H649.922V458.84H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 458.84V461.956H677.923V461.209H679.663V460.209H677.923V458.84H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 458.84V461.956H707.043V461.209H708.783V460.209H707.043V458.84H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 452.61V455.725H621.922V454.979H623.662V453.979H621.922V452.61H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 452.61V455.725H649.922V454.979H651.662V453.979H649.922V452.61H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 452.61V455.725H677.923V454.979H679.663V453.979H677.923V452.61H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 452.61V455.725H707.043V454.979H708.783V453.979H707.043V452.61H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.922 466.318V469.434H621.922V468.687H623.662V467.687H621.922V466.318H620.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M648.922 466.318V469.434H649.922V468.687H651.662V467.687H649.922V466.318H648.922Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.923 466.318V469.434H677.923V468.687H679.663V467.687H677.923V466.318H676.923Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.043 466.318V469.434H707.043V468.687H708.783V467.687H707.043V466.318H706.043Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 458.84V461.956H643.882V461.209H642.142V460.209H643.882V458.84H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 458.84V461.956H671.883V461.209H670.143V460.209H671.883V458.84H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 458.84V461.956H699.883V461.209H698.143V460.209H699.883V458.84H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 458.84V461.956H729.005V461.209H727.264V460.209H729.005V458.84H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 452.61V455.725H643.882V454.979H642.142V453.979H643.882V452.61H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 452.61V455.725H671.883V454.979H670.143V453.979H671.883V452.61H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 452.61V455.725H699.883V454.979H698.143V453.979H699.883V452.61H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 452.61V455.725H729.005V454.979H727.264V453.979H729.005V452.61H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.882 466.318V469.434H643.882V468.687H642.142V467.687H643.882V466.318H644.882Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672.883 466.318V469.434H671.883V468.687H670.143V467.687H671.883V466.318H672.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.883 466.318V469.434H699.883V468.687H698.143V467.687H699.883V466.318H700.883Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M730.005 466.318V469.434H729.005V468.687H727.264V467.687H729.005V466.318H730.005Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.302 443.263V445.755H645.502V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.302 443.263V445.755H673.503V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.303 443.263V445.755H701.503V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.423 443.263V445.755H730.624V443.263",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 478.78V476.288H646.062V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 478.78V476.288H674.063V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 478.78V476.288H702.064V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 478.78V476.288H731.184V478.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.862 448.248H623.662V473.172H621.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.862 448.248H651.662V473.172H649.422",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.863 448.248H679.663V473.172H677.423",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.984 448.248H708.784V473.172H706.544",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.942 448.871H642.142V473.795H644.382",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.943 448.871H670.143V473.795H672.383",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.944 448.871H698.144V473.795H700.384",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.064 448.871H727.264V473.795H729.504",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 460.087V449.494H639.902V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 460.087V449.494H667.902V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 460.087V449.494H695.903V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 460.087V449.494H725.024V460.087",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.342 474.418V463.825H639.902V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 474.418V463.825H667.902V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.343 474.418V463.825H695.903V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.464 474.418V463.825H725.024V474.418",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.9 621.474V617.735H1251.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.9 621.474V617.735H1279.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.9 621.474V617.735H1307.06V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.02 621.474V617.735H1336.18V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.16 598.419V601.534H1229.16V600.788H1230.9V599.788H1229.16V598.419H1228.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.16 598.419V601.534H1257.16V600.788H1258.9V599.788H1257.16V598.419H1256.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1284.16 598.419V601.534H1285.16V600.788H1286.9V599.788H1285.16V598.419H1284.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.28 598.419V601.534H1314.28V600.788H1316.02V599.788H1314.28V598.419H1313.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.16 592.187V595.303H1229.16V594.556H1230.9V593.556H1229.16V592.187H1228.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.16 592.187V595.303H1257.16V594.556H1258.9V593.556H1257.16V592.187H1256.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1284.16 592.187V595.303H1285.16V594.556H1286.9V593.556H1285.16V592.187H1284.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.28 592.187V595.303H1314.28V594.556H1316.02V593.556H1314.28V592.187H1313.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1228.16 605.897V609.012H1229.16V608.266H1230.9V607.266H1229.16V605.897H1228.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.16 605.897V609.012H1257.16V608.266H1258.9V607.266H1257.16V605.897H1256.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1284.16 605.897V609.012H1285.16V608.266H1286.9V607.266H1285.16V605.897H1284.16Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.28 605.897V609.012H1314.28V608.266H1316.02V607.266H1314.28V605.897H1313.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.12 598.419V601.534H1251.12V600.788H1249.38V599.788H1251.12V598.419H1252.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.12 598.419V601.534H1279.12V600.788H1277.38V599.788H1279.12V598.419H1280.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.12 598.419V601.534H1307.12V600.788H1305.38V599.788H1307.12V598.419H1308.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.24 598.419V601.534H1336.24V600.788H1334.5V599.788H1336.24V598.419H1337.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.12 592.187V595.303H1251.12V594.556H1249.38V593.556H1251.12V592.187H1252.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.12 592.187V595.303H1279.12V594.556H1277.38V593.556H1279.12V592.187H1280.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.12 592.187V595.303H1307.12V594.556H1305.38V593.556H1307.12V592.187H1308.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.24 592.187V595.303H1336.24V594.556H1334.5V593.556H1336.24V592.187H1337.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1252.12 605.897V609.012H1251.12V608.266H1249.38V607.266H1251.12V605.897H1252.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.12 605.897V609.012H1279.12V608.266H1277.38V607.266H1279.12V605.897H1280.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.12 605.897V609.012H1307.12V608.266H1305.38V607.266H1307.12V605.897H1308.12Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.24 605.897V609.012H1336.24V608.266H1334.5V607.266H1336.24V605.897H1337.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.54 582.841V585.333H1252.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.54 582.841V585.333H1280.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.54 582.841V585.333H1308.74V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.66 582.841V585.333H1337.86V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.1 618.358V615.866H1253.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.1 618.358V615.866H1281.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.1 618.358V615.866H1309.3V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.22 618.358V615.866H1338.42V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.1 587.826H1230.9V612.75H1228.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.1 587.826H1258.9V612.75H1256.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.1 587.826H1286.9V612.75H1284.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.22 587.826H1316.02V612.75H1313.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.18 588.449H1249.38V613.373H1251.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.18 588.449H1277.38V613.373H1279.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.18 588.449H1305.38V613.373H1307.62",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.3 588.449H1334.5V613.373H1336.74",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.58 599.665V589.072H1247.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.58 599.665V589.072H1275.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.58 599.665V589.072H1303.14V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.7 599.665V589.072H1332.26V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.58 613.996V603.403H1247.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.58 613.996V603.403H1275.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.58 613.996V603.403H1303.14V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.7 613.996V603.403H1332.26V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.06 621.474V617.735H954.221V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.061 621.474V617.735H982.222V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.062 621.474V617.735H1010.22V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.18 621.474V617.735H1039.34V621.474",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 598.419V601.534H932.321V600.788H934.061V599.788H932.321V598.419H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 598.419V601.534H960.321V600.788H962.061V599.788H960.321V598.419H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 598.419V601.534H988.322V600.788H990.062V599.788H988.322V598.419H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 598.419V601.534H1017.44V600.788H1019.18V599.788H1017.44V598.419H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 592.187V595.303H932.321V594.556H934.061V593.556H932.321V592.187H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 592.187V595.303H960.321V594.556H962.061V593.556H960.321V592.187H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 592.187V595.303H988.322V594.556H990.062V593.556H988.322V592.187H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 592.187V595.303H1017.44V594.556H1019.18V593.556H1017.44V592.187H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 605.897V609.012H932.321V608.266H934.061V607.266H932.321V605.897H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 605.897V609.012H960.321V608.266H962.061V607.266H960.321V605.897H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 605.897V609.012H988.322V608.266H990.062V607.266H988.322V605.897H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 605.897V609.012H1017.44V608.266H1019.18V607.266H1017.44V605.897H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 598.419V601.534H954.281V600.788H952.541V599.788H954.281V598.419H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 598.419V601.534H982.282V600.788H980.542V599.788H982.282V598.419H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 598.419V601.534H1010.28V600.788H1008.54V599.788H1010.28V598.419H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 598.419V601.534H1039.4V600.788H1037.66V599.788H1039.4V598.419H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 592.187V595.303H954.281V594.556H952.541V593.556H954.281V592.187H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 592.187V595.303H982.282V594.556H980.542V593.556H982.282V592.187H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 592.187V595.303H1010.28V594.556H1008.54V593.556H1010.28V592.187H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 592.187V595.303H1039.4V594.556H1037.66V593.556H1039.4V592.187H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 605.897V609.012H954.281V608.266H952.541V607.266H954.281V605.897H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 605.897V609.012H982.282V608.266H980.542V607.266H982.282V605.897H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 605.897V609.012H1010.28V608.266H1008.54V607.266H1010.28V605.897H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 605.897V609.012H1039.4V608.266H1037.66V607.266H1039.4V605.897H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.701 582.841V585.333H955.901V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.701 582.841V585.333H983.902V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.702 582.841V585.333H1011.9V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.82 582.841V585.333H1041.02V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.261 618.358V615.866H956.461V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.261 618.358V615.866H984.462V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.262 618.358V615.866H1012.46V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.38 618.358V615.866H1041.58V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.261 587.826H934.061V612.75H931.821",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.261 587.826H962.061V612.75H959.821",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.262 587.826H990.062V612.75H987.822",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.38 587.826H1019.18V612.75H1016.94",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.341 588.449H952.541V613.373H954.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.342 588.449H980.542V613.373H982.782",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.34 588.449H1008.54V613.373H1010.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.46 588.449H1037.66V613.373H1039.9",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.741 599.665V589.072H950.301V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.741 599.665V589.072H978.301V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.742 599.665V589.072H1006.3V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.86 599.665V589.072H1035.42V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.741 613.996V603.403H950.301V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.741 613.996V603.403H978.301V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.742 613.996V603.403H1006.3V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.86 613.996V603.403H1035.42V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.06 585.333V581.595H954.221V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.061 585.333V581.595H982.222V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.062 585.333V581.595H1010.22V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.18 585.333V581.595H1039.34V585.333",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 562.278V565.394H932.321V564.647H934.061V563.647H932.321V562.278H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 562.278V565.394H960.321V564.647H962.061V563.647H960.321V562.278H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 562.278V565.394H988.322V564.647H990.062V563.647H988.322V562.278H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 562.278V565.394H1017.44V564.647H1019.18V563.647H1017.44V562.278H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 556.047V559.163H932.321V558.416H934.061V557.416H932.321V556.047H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 556.047V559.163H960.321V558.416H962.061V557.416H960.321V556.047H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 556.047V559.163H988.322V558.416H990.062V557.416H988.322V556.047H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 556.047V559.163H1017.44V558.416H1019.18V557.416H1017.44V556.047H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931.321 569.755V572.871H932.321V572.124H934.061V571.124H932.321V569.755H931.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.321 569.755V572.871H960.321V572.124H962.061V571.124H960.321V569.755H959.321Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987.322 569.755V572.871H988.322V572.124H990.062V571.124H988.322V569.755H987.322Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016.44 569.755V572.871H1017.44V572.124H1019.18V571.124H1017.44V569.755H1016.44Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 562.278V565.394H954.281V564.647H952.541V563.647H954.281V562.278H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 562.278V565.394H982.282V564.647H980.542V563.647H982.282V562.278H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 562.278V565.394H1010.28V564.647H1008.54V563.647H1010.28V562.278H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 562.278V565.394H1039.4V564.647H1037.66V563.647H1039.4V562.278H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 556.047V559.163H954.281V558.416H952.541V557.416H954.281V556.047H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 556.047V559.163H982.282V558.416H980.542V557.416H982.282V556.047H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 556.047V559.163H1010.28V558.416H1008.54V557.416H1010.28V556.047H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 556.047V559.163H1039.4V558.416H1037.66V557.416H1039.4V556.047H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M955.281 569.755V572.871H954.281V572.124H952.541V571.124H954.281V569.755H955.281Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.282 569.755V572.871H982.282V572.124H980.542V571.124H982.282V569.755H983.282Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1011.28 569.755V572.871H1010.28V572.124H1008.54V571.124H1010.28V569.755H1011.28Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.4 569.755V572.871H1039.4V572.124H1037.66V571.124H1039.4V569.755H1040.4Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.701 546.7V549.193H955.901V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.701 546.7V549.193H983.902V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.702 546.7V549.193H1011.9V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.82 546.7V549.193H1041.02V546.7",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.261 582.218V579.725H956.461V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.261 582.218V579.725H984.462V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.262 582.218V579.725H1012.46V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.38 582.218V579.725H1041.58V582.218",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.261 551.685H934.061V576.61H931.821",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.261 551.685H962.061V576.61H959.821",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.262 551.685H990.062V576.61H987.822",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.38 551.685H1019.18V576.61H1016.94",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.341 552.308H952.541V577.233H954.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.342 552.308H980.542V577.233H982.782",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.34 552.308H1008.54V577.233H1010.78",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.46 552.308H1037.66V577.233H1039.9",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.741 563.524V552.931H950.301V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.741 563.524V552.931H978.301V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.742 563.524V552.931H1006.3V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.86 563.524V552.931H1035.42V563.524",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.741 577.856V567.263H950.301V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.741 577.856V567.263H978.301V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.742 577.856V567.263H1006.3V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.86 577.856V567.263H1035.42V577.856",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.6 621.474V617.735H1243.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.6 621.474V617.735H1271.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.6 621.474V617.735H1299.76V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.72 621.474V617.735H1328.88V621.474",
    stroke: "#3253DC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1220.86 598.419V601.534H1221.86V600.788H1223.6V599.788H1221.86V598.419H1220.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.86 598.419V601.534H1249.86V600.788H1251.6V599.788H1249.86V598.419H1248.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.86 598.419V601.534H1277.86V600.788H1279.6V599.788H1277.86V598.419H1276.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.98 598.419V601.534H1306.98V600.788H1308.72V599.788H1306.98V598.419H1305.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1220.86 592.187V595.303H1221.86V594.556H1223.6V593.556H1221.86V592.187H1220.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.86 592.187V595.303H1249.86V594.556H1251.6V593.556H1249.86V592.187H1248.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.86 592.187V595.303H1277.86V594.556H1279.6V593.556H1277.86V592.187H1276.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.98 592.187V595.303H1306.98V594.556H1308.72V593.556H1306.98V592.187H1305.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1220.86 605.897V609.012H1221.86V608.266H1223.6V607.266H1221.86V605.897H1220.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1248.86 605.897V609.012H1249.86V608.266H1251.6V607.266H1249.86V605.897H1248.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.86 605.897V609.012H1277.86V608.266H1279.6V607.266H1277.86V605.897H1276.86Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.98 605.897V609.012H1306.98V608.266H1308.72V607.266H1306.98V605.897H1305.98Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.82 598.419V601.534H1243.82V600.788H1242.08V599.788H1243.82V598.419H1244.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.82 598.419V601.534H1271.82V600.788H1270.08V599.788H1271.82V598.419H1272.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1300.82 598.419V601.534H1299.82V600.788H1298.08V599.788H1299.82V598.419H1300.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.94 598.419V601.534H1328.94V600.788H1327.2V599.788H1328.94V598.419H1329.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.82 592.187V595.303H1243.82V594.556H1242.08V593.556H1243.82V592.187H1244.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.82 592.187V595.303H1271.82V594.556H1270.08V593.556H1271.82V592.187H1272.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1300.82 592.187V595.303H1299.82V594.556H1298.08V593.556H1299.82V592.187H1300.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.94 592.187V595.303H1328.94V594.556H1327.2V593.556H1328.94V592.187H1329.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.82 605.897V609.012H1243.82V608.266H1242.08V607.266H1243.82V605.897H1244.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.82 605.897V609.012H1271.82V608.266H1270.08V607.266H1271.82V605.897H1272.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1300.82 605.897V609.012H1299.82V608.266H1298.08V607.266H1299.82V605.897H1300.82Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.94 605.897V609.012H1328.94V608.266H1327.2V607.266H1328.94V605.897H1329.94Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.24 582.841V585.333H1245.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.24 582.841V585.333H1273.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.24 582.841V585.333H1301.44V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.36 582.841V585.333H1330.56V582.841",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.8 618.358V615.866H1246V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.8 618.358V615.866H1274V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.8 618.358V615.866H1302V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.92 618.358V615.866H1331.12V618.358",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.8 587.826H1223.6V612.75H1221.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.8 587.826H1251.6V612.75H1249.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.8 587.826H1279.6V612.75H1277.36",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.92 587.826H1308.72V612.75H1306.48",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.88 588.449H1242.08V613.373H1244.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.88 588.449H1270.08V613.373H1272.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.88 588.449H1298.08V613.373H1300.32",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330 588.449H1327.2V613.373H1329.44",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.28 599.665V589.072H1239.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.28 599.665V589.072H1267.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.28 599.665V589.072H1295.84V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.4 599.665V589.072H1324.96V599.665",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.28 613.996V603.403H1239.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.28 613.996V603.403H1267.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.28 613.996V603.403H1295.84V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.4 613.996V603.403H1324.96V613.996",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.12 590.012V586.634H1246.33V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.41 590.012V586.634H1271.63V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.71 590.012V586.634H1296.93V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.02 590.012V586.634H1323.24V590.012",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.59 569.182V571.997H1226.59V571.371H1228.12V570.371H1226.59V569.182H1225.59Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.89 569.182V571.997H1251.89V571.371H1253.41V570.371H1251.89V569.182H1250.89Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.19 569.182V571.997H1277.19V571.371H1278.71V570.371H1277.19V569.182H1276.19Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.5 569.182V571.997H1303.5V571.371H1305.02V570.371H1303.5V569.182H1302.5Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.59 563.552V566.367H1226.59V565.741H1228.12V564.741H1226.59V563.552H1225.59Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.89 563.552V566.367H1251.89V565.741H1253.41V564.741H1251.89V563.552H1250.89Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.19 563.552V566.367H1277.19V565.741H1278.71V564.741H1277.19V563.552H1276.19Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.5 563.552V566.367H1303.5V565.741H1305.02V564.741H1303.5V563.552H1302.5Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.59 575.937V578.752H1226.59V578.126H1228.12V577.126H1226.59V575.937H1225.59Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.89 575.937V578.752H1251.89V578.126H1253.41V577.126H1251.89V575.937H1250.89Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.19 575.937V578.752H1277.19V578.126H1278.71V577.126H1277.19V575.937H1276.19Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.5 575.937V578.752H1303.5V578.126H1305.02V577.126H1303.5V575.937H1302.5Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.34 569.182V571.997H1246.34V571.371H1244.81V570.371H1246.34V569.182H1247.34Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.63 569.182V571.997H1271.63V571.371H1270.11V570.371H1271.63V569.182H1272.63Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1297.93 569.182V571.997H1296.93V571.371H1295.41V570.371H1296.93V569.182H1297.93Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.24 569.182V571.997H1323.24V571.371H1321.72V570.371H1323.24V569.182H1324.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.34 563.552V566.367H1246.34V565.741H1244.81V564.741H1246.34V563.552H1247.34Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.63 563.552V566.367H1271.63V565.741H1270.11V564.741H1271.63V563.552H1272.63Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1297.93 563.552V566.367H1296.93V565.741H1295.41V564.741H1296.93V563.552H1297.93Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.24 563.552V566.367H1323.24V565.741H1321.72V564.741H1323.24V563.552H1324.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.34 575.937V578.752H1246.34V578.126H1244.81V577.126H1246.34V575.937H1247.34Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1272.63 575.937V578.752H1271.63V578.126H1270.11V577.126H1271.63V575.937H1272.63Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1297.93 575.937V578.752H1296.93V578.126H1295.41V577.126H1296.93V575.937H1297.93Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.24 575.937V578.752H1323.24V578.126H1321.72V577.126H1323.24V575.937H1324.24Z",
    fill: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.08 555.107V557.359H1247.85V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.38 555.107V557.359H1273.15V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.68 555.107V557.359H1298.44V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.99 555.107V557.359H1324.75V555.107",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.59 587.197V584.945H1248.35V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.88 587.197V584.945H1273.65V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.18 587.197V584.945H1298.95V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.49 587.197V584.945H1325.26V587.197",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.59 559.612H1228.12V582.131H1226.09",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.88 559.612H1253.41V582.131H1251.39",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.18 559.612H1278.71V582.131H1276.69",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.49 559.612H1305.02V582.131H1303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.34 560.175H1244.81V582.694H1246.84",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.64 560.175H1270.11V582.694H1272.13",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.94 560.175H1295.41V582.694H1297.43",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.25 560.175H1321.72V582.694H1323.74",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.63 570.307V560.737H1242.79V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.93 570.307V560.737H1268.09V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.23 570.307V560.737H1293.38V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.54 570.307V560.737H1319.7V570.307",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.63 583.257V573.686H1242.79V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.93 583.257V573.686H1268.09V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.23 583.257V573.686H1293.38V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.54 583.257V573.686H1319.7V583.257",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 651.212V622.212",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.5 289.712H788.5V382.712H804.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.5 289.712H843.5V382.712H860.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.5 289.712H896.5V382.712H912.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.5 202.712H978.5V236.712H994.5V202.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 289.712H809.5V382.712H826.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 289.712H862.5V382.712H879.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.5 289.712H916.5V382.712H933.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.5 289.712H933.5V382.712H950.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.5 202.712H994.5V236.712H1011.5V202.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.5 289.712H826.5V382.712H843.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.5 289.712H879.5V382.712H896.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.5 289.712H788.5V334.712H804.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.5 289.712H843.5V334.712H860.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.5 289.712H896.5V334.712H912.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 289.712H809.5V334.712H826.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 289.712H862.5V334.712H879.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.5 289.712H916.5V334.712H933.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.5 289.712H933.5V334.712H950.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.5 289.712H950.5V382.712H967.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.5 289.712H950.5V334.712H967.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.5 202.712H994.5V218.712H1011.5V202.712Z",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.5 289.712H826.5V334.712H843.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.5 289.712H879.5V334.712H896.5V289.712Z",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 193.212H218V306.212H666V193.212Z",
    stroke: "#1593B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966 201.212H788V289.212H966V201.212Z",
    stroke: "#1593B0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 173.212H953",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 316.212H666",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 333.212H666",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 350.212H666",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 368.212H666",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.857 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.829 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.792 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.754 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.726 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.688 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.651 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.622 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.585 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.547 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.519 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.481 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.444 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.416 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.378 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.34 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.312 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.284 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.71 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.127 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.554 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.971 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.397 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.256 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.682 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.099 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.526 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.943 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.369 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.218 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.645 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.062 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.488 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.905 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.332 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.18 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.607 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.024 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.45 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.867 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.294 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.152 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.579 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.996 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.422 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.839 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.266 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.115 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.541 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.958 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.385 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.802 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.228 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.077 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.503 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.921 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.347 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.764 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.191 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.049 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.475 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.892 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.319 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.736 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.162 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.011 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.438 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.855 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.281 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.698 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.125 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.974 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.4 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.817 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.244 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.661 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.087 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.945 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.372 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.789 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.215 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.632 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.059 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.908 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.334 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.751 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.178 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.595 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.021 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.87 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.297 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.714 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.14 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.557 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.984 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.842 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.268 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.685 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.112 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.529 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.955 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.804 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.231 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.648 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.074 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.491 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.918 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.767 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.193 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.61 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.037 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.454 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.88 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.739 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.165 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.582 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.009 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.426 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.852 273.775V245.048",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.009 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.98 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.943 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.905 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.877 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.839 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.802 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.773 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.736 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.698 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.67 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.632 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.595 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.567 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.529 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.491 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.463 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.435 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.861 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.28 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.7 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.12 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.55 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.407 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.833 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.25 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.68 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.09 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.52 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.369 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.796 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.21 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.64 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.06 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.48 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.332 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.758 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.18 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.6 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.02 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.45 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.303 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.73 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.15 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.57 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.99 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.42 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.266 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.692 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.11 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.54 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.95 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.38 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.228 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.655 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.07 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.92 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.34 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.2 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.63 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.04 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.47 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.89 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.31 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.162 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.59 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.01 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.43 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.85 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.28 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.125 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.55 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.97 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.39 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.81 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.24 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.097 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.52 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.94 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.37 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.78 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.21 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.059 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.48 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.9 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.33 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.75 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.17 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.021 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.45 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.86 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.29 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.71 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.13 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.993 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1022.42 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.84 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.26 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.68 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.955 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.38 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.8 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.23 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.64 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.07 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.918 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.34 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.76 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.19 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.6 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.03 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.89 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.32 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.73 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.16 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.58 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 650.202V621.475",
    stroke: "#3253DC",
    strokeWidth: 0.8423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.406 381.85H282.667V361.69H286.406",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.406 353.849H282.667V333.689H286.406",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.406 325.85H282.667V305.689H286.406",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.406 296.729H282.667V276.568H286.406",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 384.59H266.466V383.59H265.72V381.85H264.72V383.59H263.35V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 356.589H266.466V355.589H265.72V353.849H264.72V355.589H263.35V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 328.589H266.466V327.589H265.72V325.849H264.72V327.589H263.35V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 299.468H266.466V298.468H265.72V296.728H264.72V298.468H263.35V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 384.59H260.235V383.59H259.488V381.85H258.488V383.59H257.119V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 356.589H260.235V355.589H259.488V353.849H258.488V355.589H257.119V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 328.589H260.235V327.589H259.488V325.849H258.488V327.589H257.119V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 299.468H260.235V298.468H259.488V296.728H258.488V298.468H257.119V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 384.59H273.943V383.59H273.197V381.85H272.197V383.59H270.828V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 356.589H273.943V355.589H273.197V353.849H272.197V355.589H270.828V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 328.589H273.943V327.589H273.197V325.849H272.197V327.589H270.828V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 299.468H273.943V298.468H273.197V296.728H272.197V298.468H270.828V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 360.63H266.466V361.63H265.72V363.37H264.72V361.63H263.35V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 332.628H266.466V333.628H265.72V335.368H264.72V333.628H263.35V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 304.629H266.466V305.629H265.72V307.369H264.72V305.629H263.35V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.35 275.507H266.466V276.507H265.72V278.247H264.72V276.507H263.35V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 360.63H260.235V361.63H259.488V363.37H258.488V361.63H257.119V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 332.628H260.235V333.628H259.488V335.368H258.488V333.628H257.119V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 304.629H260.235V305.629H259.488V307.369H258.488V305.629H257.119V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.119 275.507H260.235V276.507H259.488V278.247H258.488V276.507H257.119V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 360.63H273.943V361.63H273.197V363.37H272.197V361.63H270.828V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 332.628H273.943V333.628H273.197V335.368H272.197V333.628H270.828V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 304.629H273.943V305.629H273.197V307.369H272.197V305.629H270.828V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.828 275.507H273.943V276.507H273.197V278.247H272.197V276.507H270.828V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.772 385.21H250.265V360.009H247.772",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.772 357.21H250.265V332.01H247.772",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.772 329.208H250.265V304.008H247.772",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.772 300.088H250.265V274.888H247.772",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29 384.65H280.797V359.449H283.29",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29 356.649H280.797V331.449H283.29",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29 328.649H280.797V303.449H283.29",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.29 299.528H280.797V274.328H283.29",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.757 384.65V381.85H277.682V384.09",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.757 356.649V353.849H277.682V356.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.757 328.649V325.849H277.682V328.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.757 299.528V296.728H277.682V298.968",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38 360.569V363.369H278.305V361.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38 332.569V335.369H278.305V333.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38 304.568V307.368H278.305V305.128",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.38 275.447V278.247H278.305V276.007",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.596 380.17H254.003V365.61H264.596",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.596 352.17H254.003V337.61H264.596",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.596 324.168H254.003V309.608H264.596",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.596 295.048H254.003V280.488H264.596",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 380.17H268.335V365.61H278.928",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 352.17H268.335V337.61H278.928",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 324.168H268.335V309.608H278.928",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.928 295.048H268.335V280.488H278.928",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.591 381.85H315.852V361.69H319.591",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.591 353.849H315.852V333.689H319.591",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.591 325.85H315.852V305.689H319.591",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.591 296.729H315.852V276.568H319.591",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 384.59H299.651V383.59H298.904V381.85H297.904V383.59H296.535V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 356.589H299.651V355.589H298.904V353.849H297.904V355.589H296.535V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 328.589H299.651V327.589H298.904V325.849H297.904V327.589H296.535V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 299.468H299.651V298.468H298.904V296.728H297.904V298.468H296.535V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 384.59H293.42V383.59H292.673V381.85H291.673V383.59H290.304V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 356.589H293.42V355.589H292.673V353.849H291.673V355.589H290.304V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 328.589H293.42V327.589H292.673V325.849H291.673V327.589H290.304V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 299.468H293.42V298.468H292.673V296.728H291.673V298.468H290.304V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 384.59H307.128V383.59H306.382V381.85H305.382V383.59H304.012V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 356.589H307.128V355.589H306.382V353.849H305.382V355.589H304.012V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 328.589H307.128V327.589H306.382V325.849H305.382V327.589H304.012V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 299.468H307.128V298.468H306.382V296.728H305.382V298.468H304.012V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 360.63H299.651V361.63H298.904V363.37H297.904V361.63H296.535V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 332.628H299.651V333.628H298.904V335.368H297.904V333.628H296.535V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 304.629H299.651V305.629H298.904V307.369H297.904V305.629H296.535V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.535 275.507H299.651V276.507H298.904V278.247H297.904V276.507H296.535V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 360.63H293.42V361.63H292.673V363.37H291.673V361.63H290.304V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 332.628H293.42V333.628H292.673V335.368H291.673V333.628H290.304V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 304.629H293.42V305.629H292.673V307.369H291.673V305.629H290.304V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.304 275.507H293.42V276.507H292.673V278.247H291.673V276.507H290.304V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 360.63H307.128V361.63H306.382V363.37H305.382V361.63H304.012V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 332.628H307.128V333.628H306.382V335.368H305.382V333.628H304.012V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 304.629H307.128V305.629H306.382V307.369H305.382V305.629H304.012V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.012 275.507H307.128V276.507H306.382V278.247H305.382V276.507H304.012V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.957 385.21H283.45V360.009H280.957",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.957 357.21H283.45V332.01H280.957",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.957 329.208H283.45V304.008H280.957",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.957 300.088H283.45V274.888H280.957",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.475 384.65H313.982V359.449H316.475",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.475 356.649H313.982V331.449H316.475",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.475 328.649H313.982V303.449H316.475",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.475 299.528H313.982V274.328H316.475",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.942 384.65V381.85H310.867V384.09",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.942 356.649V353.849H310.867V356.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.942 328.649V325.849H310.867V328.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.942 299.528V296.728H310.867V298.968",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.565 360.569V363.369H311.49V361.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.565 332.569V335.369H311.49V333.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.565 304.568V307.368H311.49V305.128",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.565 275.447V278.247H311.49V276.007",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.781 380.17H287.188V365.61H297.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.781 352.17H287.188V337.61H297.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.781 324.168H287.188V309.608H297.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.781 295.048H287.188V280.488H297.781",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.113 380.17H301.52V365.61H312.113",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.113 352.17H301.52V337.61H312.113",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.113 324.168H301.52V309.608H312.113",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.113 295.048H301.52V280.488H312.113",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.776 381.85H349.037V361.69H352.776",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.776 353.849H349.037V333.689H352.776",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.776 325.85H349.037V305.689H352.776",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.776 296.729H349.037V276.568H352.776",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 384.59H332.836V383.59H332.089V381.85H331.089V383.59H329.72V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 356.589H332.836V355.589H332.089V353.849H331.089V355.589H329.72V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 328.589H332.836V327.589H332.089V325.849H331.089V327.589H329.72V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 299.468H332.836V298.468H332.089V296.728H331.089V298.468H329.72V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 384.59H326.605V383.59H325.858V381.85H324.858V383.59H323.489V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 356.589H326.605V355.589H325.858V353.849H324.858V355.589H323.489V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 328.589H326.605V327.589H325.858V325.849H324.858V327.589H323.489V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 299.468H326.605V298.468H325.858V296.728H324.858V298.468H323.489V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 384.59H340.313V383.59H339.567V381.85H338.567V383.59H337.198V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 356.589H340.313V355.589H339.567V353.849H338.567V355.589H337.198V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 328.589H340.313V327.589H339.567V325.849H338.567V327.589H337.198V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 299.468H340.313V298.468H339.567V296.728H338.567V298.468H337.198V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 360.63H332.836V361.63H332.089V363.37H331.089V361.63H329.72V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 332.628H332.836V333.628H332.089V335.368H331.089V333.628H329.72V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 304.629H332.836V305.629H332.089V307.369H331.089V305.629H329.72V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.72 275.507H332.836V276.507H332.089V278.247H331.089V276.507H329.72V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 360.63H326.605V361.63H325.858V363.37H324.858V361.63H323.489V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 332.628H326.605V333.628H325.858V335.368H324.858V333.628H323.489V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 304.629H326.605V305.629H325.858V307.369H324.858V305.629H323.489V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.489 275.507H326.605V276.507H325.858V278.247H324.858V276.507H323.489V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 360.63H340.313V361.63H339.567V363.37H338.567V361.63H337.198V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 332.628H340.313V333.628H339.567V335.368H338.567V333.628H337.198V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 304.629H340.313V305.629H339.567V307.369H338.567V305.629H337.198V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.198 275.507H340.313V276.507H339.567V278.247H338.567V276.507H337.198V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.142 385.21H316.635V360.009H314.142",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.142 357.21H316.635V332.01H314.142",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.142 329.208H316.635V304.008H314.142",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.142 300.088H316.635V274.888H314.142",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66 384.65H347.167V359.449H349.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66 356.649H347.167V331.449H349.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66 328.649H347.167V303.449H349.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66 299.528H347.167V274.328H349.66",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.127 384.65V381.85H344.052V384.09",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.127 356.649V353.849H344.052V356.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.127 328.649V325.849H344.052V328.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.127 299.528V296.728H344.052V298.968",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75 360.569V363.369H344.675V361.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75 332.569V335.369H344.675V333.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75 304.568V307.368H344.675V305.128",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75 275.447V278.247H344.675V276.007",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.966 380.17H320.373V365.61H330.966",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.966 352.17H320.373V337.61H330.966",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.966 324.168H320.373V309.608H330.966",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.966 295.048H320.373V280.488H330.966",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.298 380.17H334.705V365.61H345.298",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.298 352.17H334.705V337.61H345.298",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.298 324.168H334.705V309.608H345.298",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.298 295.048H334.705V280.488H345.298",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.961 381.85H382.222V361.69H385.961",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.961 353.849H382.222V333.689H385.961",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.961 325.85H382.222V305.689H385.961",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.961 296.729H382.222V276.568H385.961",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 384.59H366.021V383.59H365.275V381.85H364.275V383.59H362.905V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 356.589H366.021V355.589H365.275V353.849H364.275V355.589H362.905V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 328.589H366.021V327.589H365.275V325.849H364.275V327.589H362.905V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 299.468H366.021V298.468H365.275V296.728H364.275V298.468H362.905V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 384.59H359.79V383.59H359.043V381.85H358.043V383.59H356.674V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 356.589H359.79V355.589H359.043V353.849H358.043V355.589H356.674V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 328.589H359.79V327.589H359.043V325.849H358.043V327.589H356.674V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 299.468H359.79V298.468H359.043V296.728H358.043V298.468H356.674V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 384.59H373.498V383.59H372.752V381.85H371.752V383.59H370.383V384.59Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 356.589H373.498V355.589H372.752V353.849H371.752V355.589H370.383V356.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 328.589H373.498V327.589H372.752V325.849H371.752V327.589H370.383V328.589Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 299.468H373.498V298.468H372.752V296.728H371.752V298.468H370.383V299.468Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 360.63H366.021V361.63H365.275V363.37H364.275V361.63H362.905V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 332.628H366.021V333.628H365.275V335.368H364.275V333.628H362.905V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 304.629H366.021V305.629H365.275V307.369H364.275V305.629H362.905V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.905 275.507H366.021V276.507H365.275V278.247H364.275V276.507H362.905V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 360.63H359.79V361.63H359.043V363.37H358.043V361.63H356.674V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 332.628H359.79V333.628H359.043V335.368H358.043V333.628H356.674V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 304.629H359.79V305.629H359.043V307.369H358.043V305.629H356.674V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.674 275.507H359.79V276.507H359.043V278.247H358.043V276.507H356.674V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 360.63H373.498V361.63H372.752V363.37H371.752V361.63H370.383V360.63Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 332.628H373.498V333.628H372.752V335.368H371.752V333.628H370.383V332.628Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 304.629H373.498V305.629H372.752V307.369H371.752V305.629H370.383V304.629Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.383 275.507H373.498V276.507H372.752V278.247H371.752V276.507H370.383V275.507Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.327 385.21H349.82V360.009H347.327",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.327 357.21H349.82V332.01H347.327",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.327 329.208H349.82V304.008H347.327",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.327 300.088H349.82V274.888H347.327",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.845 384.65H380.352V359.449H382.845",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.845 356.649H380.352V331.449H382.845",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.845 328.649H380.352V303.449H382.845",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.845 299.528H380.352V274.328H382.845",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.312 384.65V381.85H377.237V384.09",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.312 356.649V353.849H377.237V356.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.312 328.649V325.849H377.237V328.089",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.312 299.528V296.728H377.237V298.968",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.935 360.569V363.369H377.86V361.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.935 332.569V335.369H377.86V333.129",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.935 304.568V307.368H377.86V305.128",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.935 275.447V278.247H377.86V276.007",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.151 380.17H353.558V365.61H364.151",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.151 352.17H353.558V337.61H364.151",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.151 324.168H353.558V309.608H364.151",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.151 295.048H353.558V280.488H364.151",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.483 380.17H367.89V365.61H378.483",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.483 352.17H367.89V337.61H378.483",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.483 324.168H367.89V309.608H378.483",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.483 295.048H367.89V280.488H378.483",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 454.632H89.2124V453.632H87.6032V450.14H86.6032V453.632H83.9399V454.632Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 404.739H89.2124V403.739H87.6032V400.248H86.6032V403.739H83.9399V404.739Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 352.851H89.2124V351.851H87.6032V348.36H86.6032V351.851H83.9399V352.851Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 454.632H78.6678V453.632H77.0591V450.14H76.0591V453.632H73.3953V454.632Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 404.739H78.6678V403.739H77.0591V400.248H76.0591V403.739H73.3953V404.739Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 352.851H78.6678V351.851H77.0591V348.36H76.0591V351.851H73.3953V352.851Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 454.632H101.867V453.632H100.258V450.14H99.258V453.632H96.5942V454.632Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 404.739H101.867V403.739H100.258V400.248H99.258V403.739H96.5942V404.739Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 352.851H101.867V351.851H100.258V348.36H99.258V351.851H96.5942V352.851Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 412.72H89.2124V413.72H87.6032V417.211H86.6032V413.72H83.9399V412.72Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 362.828H89.2124V363.828H87.6032V367.319H86.6032V363.828H83.9399V362.828Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 310.939H89.2124V311.939H87.6032V315.43H86.6032V311.939H83.9399V310.939Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 412.72H78.6678V413.72H77.0591V417.211H76.0591V413.72H73.3953V412.72Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 362.828H78.6678V363.828H77.0591V367.319H76.0591V363.828H73.3953V362.828Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 310.939H78.6678V311.939H77.0591V315.43H76.0591V311.939H73.3953V310.939Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 412.72H101.867V413.72H100.258V417.211H99.258V413.72H96.5942V412.72Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 362.828H101.867V363.828H100.258V367.319H99.258V363.828H96.5942V362.828Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 310.939H101.867V311.939H100.258V315.43H99.258V311.939H96.5942V310.939Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 456.128H61.7954V411.225H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 406.235H61.7954V361.332H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 354.347H61.7954V309.444H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 455.13H113.466V410.226H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 405.237H113.466V360.334H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 353.349H113.466V308.445H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 455.13V450.14H108.194V454.132",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 405.237V400.248H108.194V404.239",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 353.349V348.359H108.194V352.351",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 412.222V417.212H109.248V413.22",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 362.33V367.319H109.248V363.328",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 310.441V315.431H109.248V311.439",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 447.148H68.1223V421.204H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 397.254H68.1223V371.31H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 345.366H68.1223V319.422H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 447.148H92.3762V421.204H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 397.254H92.3762V371.31H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 345.366H92.3762V319.422H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 601.908H89.2124V600.908H87.6032V597.416H86.6032V600.908H83.9399V601.908Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 552.016H89.2124V551.016H87.6032V547.525H86.6032V551.016H83.9399V552.016Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 500.128H89.2124V499.128H87.6032V495.637H86.6032V499.128H83.9399V500.128Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 601.908H78.6678V600.908H77.0591V597.416H76.0591V600.908H73.3953V601.908Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 552.016H78.6678V551.016H77.0591V547.525H76.0591V551.016H73.3953V552.016Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 500.128H78.6678V499.128H77.0591V495.637H76.0591V499.128H73.3953V500.128Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 601.908H101.867V600.908H100.258V597.416H99.258V600.908H96.5942V601.908Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 552.016H101.867V551.016H100.258V547.525H99.258V551.016H96.5942V552.016Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 500.128H101.867V499.128H100.258V495.637H99.258V499.128H96.5942V500.128Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 559.997H89.2124V560.997H87.6032V564.488H86.6032V560.997H83.9399V559.997Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 510.105H89.2124V511.105H87.6032V514.596H86.6032V511.105H83.9399V510.105Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9399 458.214H89.2124V459.214H87.6032V462.705H86.6032V459.214H83.9399V458.214Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 559.997H78.6678V560.997H77.0591V564.488H76.0591V560.997H73.3953V559.997Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 510.105H78.6678V511.105H77.0591V514.596H76.0591V511.105H73.3953V510.105Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3953 458.214H78.6678V459.214H77.0591V462.705H76.0591V459.214H73.3953V458.214Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 559.997H101.867V560.997H100.258V564.488H99.258V560.997H96.5942V559.997Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 510.105H101.867V511.105H100.258V514.596H99.258V511.105H96.5942V510.105Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5942 458.214H101.867V459.214H100.258V462.705H99.258V459.214H96.5942V458.214Z",
    fill: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 603.404H61.7954V558.501H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 553.512H61.7954V508.608H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5774 501.623H61.7954V456.72H57.5774",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 602.406H113.466V557.503H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 552.513H113.466V507.61H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.684 500.625H113.466V455.722H117.684",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 602.406V597.417H108.194V601.408",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 552.513V547.524H108.194V551.515",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0139 500.625V495.636H108.194V499.627",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 559.499V564.488H109.248V560.497",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 509.605V514.594H109.248V510.603",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0681 457.718V462.707H109.248V458.716",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 594.424H68.1223V568.48H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 544.53H68.1223V518.586H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0489 492.642H68.1223V466.698H86.0489",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 594.424H92.3762V568.48H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 544.53H92.3762V518.586H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.303 492.642H92.3762V466.698H110.303",
    stroke: "#4D6994",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 173.212V190.212H633V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 316.212V333.212H553V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 333.212V350.212H553V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 350.212V368.212H553V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 368.212V385.212H553V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 173.212V190.212H614V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 316.212V333.212H534V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 333.212V350.212H534V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 350.212V368.212H534V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 368.212V385.212H534V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 173.212V190.212H595V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 173.212V190.212H577V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 316.212V333.212H515V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 333.212V350.212H515V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 350.212V368.212H515V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 368.212V385.212H515V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 316.212V333.212H496V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 333.212V350.212H496V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 350.212V368.212H496V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 368.212V385.212H496V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671 173.212V190.212H690V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 316.212V333.212H609V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 333.212V350.212H609V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 350.212V368.212H609V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591 368.212V385.212H609V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727 173.212V190.212H746V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 173.212V190.212H803V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840 173.212V190.212H859V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 173.212V190.212H652V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 316.212V333.212H572V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 333.212V350.212H572V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 350.212V368.212H572V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 368.212V385.212H572V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 173.212V190.212H708V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 316.212V333.212H628V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 333.212V350.212H628V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 350.212V368.212H628V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 368.212V385.212H628V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 316.212V333.212H647V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 333.212V350.212H647V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 350.212V368.212H647V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 368.212V385.212H647V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 316.212V333.212H666V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 333.212V350.212H666V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 350.212V368.212H666V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 368.212V385.212H666V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 173.212V181.212H953V173.212",
    stroke: "#3253DC",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 181.212V190.212H765V181.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 173.212V190.212H821V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 173.212V190.212H878V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652 173.212V190.212H671V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 316.212V333.212H591V316.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 333.212V350.212H591V333.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 350.212V368.212H591V350.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572 368.212V385.212H591V368.212",
    stroke: "#4D6994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 173.212V190.212H727V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765 173.212V190.212H784V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821 173.212V190.212H840V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 173.212V190.212H897V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897 173.212V190.212H915V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 173.212V190.212H934V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934 173.212V190.212H953V173.212",
    stroke: "#3253DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 297.212H52V609.212H129V297.212Z",
    stroke: "#1593B0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801 652.212V798.212H1353V652.212",
    stroke: "#1593B0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953 770.001H810C807.239 770.001 805 772.24 805 775.001V786.001C805 788.762 807.239 791.001 810 791.001H953C955.761 791.001 958 788.762 958 786.001V775.001C958 772.24 955.761 770.001 953 770.001Z",
    fill: "#0E64A9",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.454 785.671V782.431H815.704C818.179 782.431 819.454 780.841 819.454 778.966C819.454 777.091 818.179 775.501 815.704 775.501H811.759C811.579 775.501 811.444 775.651 811.444 775.816V785.671C811.444 785.851 811.579 786.001 811.759 786.001H813.139C813.319 786.001 813.454 785.851 813.454 785.671ZM813.454 780.661V777.271H815.569C816.574 777.271 817.369 777.916 817.369 778.966C817.369 780.016 816.574 780.661 815.569 780.661H813.454ZM829.254 786.001C829.494 786.001 829.599 785.761 829.479 785.581L827.034 781.636C828.714 781.111 829.209 779.641 829.209 778.666C829.209 776.866 827.799 775.501 825.579 775.501H820.959C820.749 775.501 820.644 775.666 820.644 775.816V785.671C820.644 785.851 820.779 786.001 820.959 786.001H822.339C822.519 786.001 822.654 785.851 822.654 785.671V781.981H824.979L827.199 785.671C827.334 785.911 827.469 786.001 827.724 786.001H829.254ZM825.354 780.346H822.654V777.271H825.384C826.389 777.271 827.094 777.856 827.094 778.771C827.094 779.701 826.389 780.346 825.354 780.346ZM841.163 780.751C841.163 777.661 838.733 775.291 835.643 775.291C832.568 775.291 830.123 777.661 830.123 780.751C830.123 783.841 832.568 786.211 835.643 786.211C838.733 786.211 841.163 783.841 841.163 780.751ZM839.078 780.751C839.078 782.776 837.638 784.351 835.643 784.351C833.648 784.351 832.223 782.776 832.223 780.751C832.223 778.726 833.648 777.151 835.643 777.151C837.638 777.151 839.078 778.726 839.078 780.751ZM846.773 775.501H842.843C842.663 775.501 842.528 775.651 842.528 775.816V785.671C842.528 785.851 842.663 786.001 842.843 786.001H846.773C850.088 786.001 852.188 783.856 852.188 780.736C852.188 777.601 850.088 775.501 846.773 775.501ZM846.803 784.156H844.538V777.346H846.803C848.753 777.346 850.088 778.726 850.088 780.736C850.088 782.731 848.753 784.156 846.803 784.156ZM862.183 782.251V775.816C862.183 775.651 862.033 775.501 861.868 775.501H860.503C860.323 775.501 860.173 775.651 860.173 775.816V782.131C860.173 783.526 859.303 784.381 857.833 784.381C856.363 784.381 855.508 783.526 855.508 782.131V775.816C855.508 775.651 855.358 775.501 855.178 775.501H853.813C853.633 775.501 853.498 775.651 853.498 775.816V782.266C853.498 784.996 855.568 786.211 857.833 786.211C860.113 786.211 862.183 784.981 862.183 782.251ZM868.983 786.211C871.263 786.211 873.303 785.011 873.993 782.956C874.038 782.821 874.053 782.686 873.828 782.626L872.328 782.251C872.103 782.206 872.043 782.356 871.998 782.461C871.458 783.556 870.453 784.351 868.998 784.351C867.003 784.351 865.563 782.776 865.563 780.751C865.563 778.726 867.003 777.151 868.998 777.151C870.453 777.151 871.458 777.946 871.998 779.041C872.043 779.146 872.103 779.296 872.328 779.251L873.828 778.876C874.053 778.816 874.038 778.681 873.993 778.546C873.303 776.491 871.263 775.291 868.983 775.291C865.893 775.291 863.463 777.661 863.463 780.751C863.463 783.841 865.893 786.211 868.983 786.211ZM874.136 777.031C874.136 777.211 874.271 777.346 874.451 777.346H877.571V785.671C877.571 785.851 877.706 786.001 877.886 786.001H879.311C879.491 786.001 879.641 785.851 879.641 785.671V777.346H882.761C882.941 777.346 883.076 777.211 883.076 777.031V775.831C883.076 775.651 882.941 775.501 882.761 775.501H874.451C874.271 775.501 874.136 775.651 874.136 775.831V777.031ZM885.898 786.001C886.078 786.001 886.213 785.851 886.213 785.671V775.816C886.213 775.651 886.078 775.501 885.898 775.501H884.518C884.338 775.501 884.203 775.651 884.203 775.816V785.671C884.203 785.851 884.338 786.001 884.518 786.001H885.898ZM898.614 780.751C898.614 777.661 896.184 775.291 893.094 775.291C890.019 775.291 887.574 777.661 887.574 780.751C887.574 783.841 890.019 786.211 893.094 786.211C896.184 786.211 898.614 783.841 898.614 780.751ZM896.529 780.751C896.529 782.776 895.089 784.351 893.094 784.351C891.099 784.351 889.674 782.776 889.674 780.751C889.674 778.726 891.099 777.151 893.094 777.151C895.089 777.151 896.529 778.726 896.529 780.751ZM906.49 785.686C906.625 785.911 906.82 786.001 907.135 786.001H908.62C908.785 786.001 908.95 785.866 908.95 785.686V775.816C908.95 775.651 908.785 775.501 908.62 775.501H907.24C907.075 775.501 906.94 775.651 906.94 775.816V782.656L902.545 775.756C902.425 775.561 902.26 775.501 902.08 775.501H900.295C900.115 775.501 899.98 775.651 899.98 775.816V785.686C899.98 785.866 900.115 786.001 900.295 786.001H901.675C901.855 786.001 901.99 785.866 901.99 785.686V778.681L906.49 785.686ZM920.738 785.716C920.813 785.896 920.888 786.001 921.068 786.001H922.643C922.883 786.001 923.048 785.821 922.928 785.521L919.133 775.816C919.043 775.591 918.863 775.501 918.713 775.501H916.853C916.703 775.501 916.523 775.591 916.433 775.816L912.653 785.536C912.548 785.821 912.683 786.001 912.908 786.001H914.393C914.558 786.001 914.663 785.881 914.723 785.716L915.578 783.451H919.868L920.738 785.716ZM916.208 781.756L917.708 777.766L919.223 781.756H916.208ZM932.466 786.001C932.706 786.001 932.811 785.761 932.691 785.581L930.246 781.636C931.926 781.111 932.421 779.641 932.421 778.666C932.421 776.866 931.011 775.501 928.791 775.501H924.171C923.961 775.501 923.856 775.666 923.856 775.816V785.671C923.856 785.851 923.991 786.001 924.171 786.001H925.551C925.731 786.001 925.866 785.851 925.866 785.671V781.981H928.191L930.411 785.671C930.546 785.911 930.681 786.001 930.936 786.001H932.466ZM928.566 780.346H925.866V777.271H928.596C929.601 777.271 930.306 777.856 930.306 778.771C930.306 779.701 929.601 780.346 928.566 780.346ZM934.294 775.501C934.114 775.501 933.979 775.651 933.979 775.816V785.671C933.979 785.851 934.114 786.001 934.294 786.001H941.779C941.959 786.001 942.109 785.851 942.109 785.671V784.471C942.109 784.291 941.959 784.156 941.779 784.156H935.989V781.621H938.959C939.139 781.621 939.274 781.471 939.274 781.291V780.151C939.274 779.971 939.139 779.821 938.959 779.821H935.989V777.346H941.689C941.869 777.346 942.004 777.211 942.004 777.031V775.831C942.004 775.651 941.869 775.501 941.689 775.501H934.294ZM950.357 785.716C950.433 785.896 950.508 786.001 950.688 786.001H952.263C952.503 786.001 952.668 785.821 952.548 785.521L948.753 775.816C948.663 775.591 948.483 775.501 948.333 775.501H946.473C946.323 775.501 946.143 775.591 946.053 775.816L942.272 785.536C942.167 785.821 942.302 786.001 942.528 786.001H944.013C944.178 786.001 944.283 785.881 944.343 785.716L945.198 783.451H949.488L950.357 785.716ZM945.828 781.756L947.328 777.766L948.843 781.756H945.828Z",
    fill: "#1593B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223 213H1075C1072.24 213 1070 215.239 1070 218V229C1070 231.761 1072.24 234 1075 234H1223C1225.76 234 1228 231.761 1228 229V218C1228 215.239 1225.76 213 1223 213Z",
    fill: "#0E64A9",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.96 218.5H1077.03C1076.85 218.5 1076.71 218.65 1076.71 218.815V228.67C1076.71 228.85 1076.85 229 1077.03 229H1080.96C1084.27 229 1086.37 226.855 1086.37 223.735C1086.37 220.6 1084.27 218.5 1080.96 218.5ZM1080.99 227.155H1078.72V220.345H1080.99C1082.94 220.345 1084.27 221.725 1084.27 223.735C1084.27 225.73 1082.94 227.155 1080.99 227.155ZM1089.46 229C1089.64 229 1089.78 228.85 1089.78 228.67V218.815C1089.78 218.65 1089.64 218.5 1089.46 218.5H1088.08C1087.9 218.5 1087.77 218.65 1087.77 218.815V228.67C1087.77 228.85 1087.9 229 1088.08 229H1089.46ZM1095.31 218.29C1093 218.29 1091.31 219.595 1091.31 221.44C1091.31 222.895 1092.22 223.87 1093.86 224.29L1095.76 224.785C1096.8 225.055 1097.34 225.43 1097.34 226.15C1097.34 226.795 1096.71 227.425 1095.45 227.425C1094.19 227.425 1093.38 226.855 1092.78 226.27C1092.57 226.06 1092.36 225.94 1092.07 226.165L1091.25 226.81C1090.96 227.035 1091.02 227.38 1091.25 227.635C1091.92 228.4 1093.27 229.21 1095.33 229.21C1098.18 229.21 1099.53 227.545 1099.53 225.955C1099.53 224.29 1098.42 223.42 1096.72 222.97L1094.67 222.43C1093.74 222.19 1093.47 221.785 1093.47 221.305C1093.47 220.51 1094.26 220.06 1095.25 220.06C1096.15 220.06 1096.89 220.45 1097.58 220.975C1097.89 221.215 1098.16 221.185 1098.37 220.975L1099 220.315C1099.15 220.165 1099.3 219.91 1098.94 219.565C1098.25 218.905 1096.96 218.29 1095.31 218.29ZM1099.81 220.03C1099.81 220.21 1099.94 220.345 1100.12 220.345H1103.24V228.67C1103.24 228.85 1103.38 229 1103.56 229H1104.98C1105.16 229 1105.31 228.85 1105.31 228.67V220.345H1108.43C1108.61 220.345 1108.75 220.21 1108.75 220.03V218.83C1108.75 218.65 1108.61 218.5 1108.43 218.5H1100.12C1099.94 218.5 1099.81 218.65 1099.81 218.83V220.03ZM1118.48 229C1118.72 229 1118.83 228.76 1118.71 228.58L1116.26 224.635C1117.94 224.11 1118.44 222.64 1118.44 221.665C1118.44 219.865 1117.03 218.5 1114.81 218.5H1110.19C1109.98 218.5 1109.87 218.665 1109.87 218.815V228.67C1109.87 228.85 1110.01 229 1110.19 229H1111.57C1111.75 229 1111.88 228.85 1111.88 228.67V224.98H1114.21L1116.43 228.67C1116.56 228.91 1116.7 229 1116.95 229H1118.48ZM1114.58 223.345H1111.88V220.27H1114.61C1115.62 220.27 1116.32 220.855 1116.32 221.77C1116.32 222.7 1115.62 223.345 1114.58 223.345ZM1121.69 229C1121.87 229 1122.01 228.85 1122.01 228.67V218.815C1122.01 218.65 1121.87 218.5 1121.69 218.5H1120.31C1120.13 218.5 1120 218.65 1120 218.815V228.67C1120 228.85 1120.13 229 1120.31 229H1121.69ZM1128.81 218.5H1124.24C1124.04 218.5 1123.92 218.65 1123.92 218.815V228.685C1123.92 228.865 1124.06 229 1124.24 229H1129.22C1131.51 229 1132.73 227.5 1132.73 225.94C1132.73 224.86 1132.16 223.795 1130.78 223.33C1131.71 222.94 1132.19 222.1 1132.19 221.155C1132.19 219.955 1131.3 218.5 1128.81 218.5ZM1130.12 221.425C1130.12 222.22 1129.56 222.775 1128.54 222.775H1125.93V220.09H1128.54C1129.56 220.09 1130.12 220.645 1130.12 221.425ZM1128.9 224.29C1129.88 224.29 1130.64 224.905 1130.64 225.85C1130.64 226.81 1129.86 227.41 1128.9 227.41H1125.93V224.29H1128.9ZM1142.65 225.25V218.815C1142.65 218.65 1142.5 218.5 1142.34 218.5H1140.97C1140.79 218.5 1140.64 218.65 1140.64 218.815V225.13C1140.64 226.525 1139.77 227.38 1138.3 227.38C1136.83 227.38 1135.98 226.525 1135.98 225.13V218.815C1135.98 218.65 1135.83 218.5 1135.65 218.5H1134.28C1134.1 218.5 1133.97 218.65 1133.97 218.815V225.265C1133.97 227.995 1136.04 229.21 1138.3 229.21C1140.58 229.21 1142.65 227.98 1142.65 225.25ZM1143.69 220.03C1143.69 220.21 1143.83 220.345 1144.01 220.345H1147.13V228.67C1147.13 228.85 1147.26 229 1147.44 229H1148.87C1149.05 229 1149.2 228.85 1149.2 228.67V220.345H1152.32C1152.5 220.345 1152.63 220.21 1152.63 220.03V218.83C1152.63 218.65 1152.5 218.5 1152.32 218.5H1144.01C1143.83 218.5 1143.69 218.65 1143.69 218.83V220.03ZM1155.46 229C1155.64 229 1155.77 228.85 1155.77 228.67V218.815C1155.77 218.65 1155.64 218.5 1155.46 218.5H1154.08C1153.9 218.5 1153.76 218.65 1153.76 218.815V228.67C1153.76 228.85 1153.9 229 1154.08 229H1155.46ZM1168.17 223.75C1168.17 220.66 1165.74 218.29 1162.65 218.29C1159.58 218.29 1157.13 220.66 1157.13 223.75C1157.13 226.84 1159.58 229.21 1162.65 229.21C1165.74 229.21 1168.17 226.84 1168.17 223.75ZM1166.09 223.75C1166.09 225.775 1164.65 227.35 1162.65 227.35C1160.66 227.35 1159.23 225.775 1159.23 223.75C1159.23 221.725 1160.66 220.15 1162.65 220.15C1164.65 220.15 1166.09 221.725 1166.09 223.75ZM1176.05 228.685C1176.18 228.91 1176.38 229 1176.69 229H1178.18C1178.34 229 1178.51 228.865 1178.51 228.685V218.815C1178.51 218.65 1178.34 218.5 1178.18 218.5H1176.8C1176.63 218.5 1176.5 218.65 1176.5 218.815V225.655L1172.1 218.755C1171.98 218.56 1171.82 218.5 1171.64 218.5H1169.85C1169.67 218.5 1169.54 218.65 1169.54 218.815V228.685C1169.54 228.865 1169.67 229 1169.85 229H1171.23C1171.41 229 1171.55 228.865 1171.55 228.685V221.68L1176.05 228.685ZM1190.3 228.715C1190.37 228.895 1190.45 229 1190.63 229H1192.2C1192.44 229 1192.61 228.82 1192.49 228.52L1188.69 218.815C1188.6 218.59 1188.42 218.5 1188.27 218.5H1186.41C1186.26 218.5 1186.08 218.59 1185.99 218.815L1182.21 228.535C1182.11 228.82 1182.24 229 1182.47 229H1183.95C1184.12 229 1184.22 228.88 1184.28 228.715L1185.14 226.45H1189.43L1190.3 228.715ZM1185.77 224.755L1187.27 220.765L1188.78 224.755H1185.77ZM1202.02 229C1202.26 229 1202.37 228.76 1202.25 228.58L1199.8 224.635C1201.48 224.11 1201.98 222.64 1201.98 221.665C1201.98 219.865 1200.57 218.5 1198.35 218.5H1193.73C1193.52 218.5 1193.41 218.665 1193.41 218.815V228.67C1193.41 228.85 1193.55 229 1193.73 229H1195.11C1195.29 229 1195.42 228.85 1195.42 228.67V224.98H1197.75L1199.97 228.67C1200.1 228.91 1200.24 229 1200.49 229H1202.02ZM1198.12 223.345H1195.42V220.27H1198.15C1199.16 220.27 1199.86 220.855 1199.86 221.77C1199.86 222.7 1199.16 223.345 1198.12 223.345ZM1203.85 218.5C1203.67 218.5 1203.54 218.65 1203.54 218.815V228.67C1203.54 228.85 1203.67 229 1203.85 229H1211.34C1211.52 229 1211.67 228.85 1211.67 228.67V227.47C1211.67 227.29 1211.52 227.155 1211.34 227.155H1205.55V224.62H1208.52C1208.7 224.62 1208.83 224.47 1208.83 224.29V223.15C1208.83 222.97 1208.7 222.82 1208.52 222.82H1205.55V220.345H1211.25C1211.43 220.345 1211.56 220.21 1211.56 220.03V218.83C1211.56 218.65 1211.43 218.5 1211.25 218.5H1203.85ZM1219.92 228.715C1219.99 228.895 1220.07 229 1220.25 229H1221.82C1222.06 229 1222.23 228.82 1222.11 228.52L1218.31 218.815C1218.22 218.59 1218.04 218.5 1217.89 218.5H1216.03C1215.88 218.5 1215.7 218.59 1215.61 218.815L1211.83 228.535C1211.73 228.82 1211.86 229 1212.09 229H1213.57C1213.74 229 1213.84 228.88 1213.9 228.715L1214.76 226.45H1219.05L1219.92 228.715ZM1215.39 224.755L1216.89 220.765L1218.4 224.755H1215.39Z",
    fill: "#1593B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922 215.001H836C833.239 215.001 831 217.24 831 220.001V231.001C831 233.762 833.239 236.001 836 236.001H922C924.761 236.001 927 233.762 927 231.001V220.001C927 217.24 924.761 215.001 922 215.001Z",
    fill: "#0E64A9",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.194 230.671V227.431H844.444C846.919 227.431 848.194 225.841 848.194 223.966C848.194 222.091 846.919 220.501 844.444 220.501H840.499C840.319 220.501 840.184 220.651 840.184 220.816V230.671C840.184 230.851 840.319 231.001 840.499 231.001H841.879C842.059 231.001 842.194 230.851 842.194 230.671ZM842.194 225.661V222.271H844.309C845.314 222.271 846.109 222.916 846.109 223.966C846.109 225.016 845.314 225.661 844.309 225.661H842.194ZM855.552 230.716C855.627 230.896 855.702 231.001 855.882 231.001H857.457C857.697 231.001 857.862 230.821 857.742 230.521L853.947 220.816C853.857 220.591 853.677 220.501 853.527 220.501H851.667C851.517 220.501 851.337 220.591 851.247 220.816L847.467 230.536C847.362 230.821 847.497 231.001 847.722 231.001H849.207C849.372 231.001 849.477 230.881 849.537 230.716L850.392 228.451H854.682L855.552 230.716ZM851.022 226.756L852.522 222.766L854.037 226.756H851.022ZM866.005 229.471C866.005 229.291 865.855 229.156 865.675 229.156H860.68V220.831C860.68 220.651 860.53 220.501 860.35 220.501H858.985C858.805 220.501 858.67 220.651 858.67 220.831V230.686C858.67 230.851 858.805 231.001 858.985 231.001H865.675C865.855 231.001 866.005 230.851 866.005 230.671V229.471ZM874.428 229.471C874.428 229.291 874.278 229.156 874.098 229.156H869.103V220.831C869.103 220.651 868.953 220.501 868.773 220.501H867.408C867.228 220.501 867.093 220.651 867.093 220.831V230.686C867.093 230.851 867.228 231.001 867.408 231.001H874.098C874.278 231.001 874.428 230.851 874.428 230.671V229.471ZM875.831 220.501C875.651 220.501 875.516 220.651 875.516 220.816V230.671C875.516 230.851 875.651 231.001 875.831 231.001H883.316C883.496 231.001 883.646 230.851 883.646 230.671V229.471C883.646 229.291 883.496 229.156 883.316 229.156H877.526V226.621H880.496C880.676 226.621 880.811 226.471 880.811 226.291V225.151C880.811 224.971 880.676 224.821 880.496 224.821H877.526V222.346H883.226C883.406 222.346 883.541 222.211 883.541 222.031V220.831C883.541 220.651 883.406 220.501 883.226 220.501H875.831ZM884.14 222.031C884.14 222.211 884.275 222.346 884.455 222.346H887.575V230.671C887.575 230.851 887.71 231.001 887.89 231.001H889.315C889.495 231.001 889.645 230.851 889.645 230.671V222.346H892.765C892.945 222.346 893.08 222.211 893.08 222.031V220.831C893.08 220.651 892.945 220.501 892.765 220.501H884.455C884.275 220.501 884.14 220.651 884.14 220.831V222.031ZM895.903 231.001C896.083 231.001 896.218 230.851 896.218 230.671V220.816C896.218 220.651 896.083 220.501 895.903 220.501H894.523C894.343 220.501 894.208 220.651 894.208 220.816V230.671C894.208 230.851 894.343 231.001 894.523 231.001H895.903ZM904.643 230.686C904.778 230.911 904.973 231.001 905.288 231.001H906.773C906.938 231.001 907.103 230.866 907.103 230.686V220.816C907.103 220.651 906.938 220.501 906.773 220.501H905.393C905.228 220.501 905.093 220.651 905.093 220.816V227.656L900.698 220.756C900.578 220.561 900.413 220.501 900.233 220.501H898.448C898.268 220.501 898.133 220.651 898.133 220.816V230.686C898.133 230.866 898.268 231.001 898.448 231.001H899.828C900.008 231.001 900.143 230.866 900.143 230.686V223.681L904.643 230.686ZM914.042 220.291C910.907 220.291 908.462 222.661 908.462 225.751C908.462 228.841 910.742 231.211 913.802 231.211C915.527 231.211 916.622 230.521 917.297 229.591V230.671C917.297 230.851 917.447 231.001 917.627 231.001H918.812C918.992 231.001 919.142 230.851 919.142 230.671V226.066C919.142 225.886 918.992 225.751 918.812 225.751H914.297C914.117 225.751 913.967 225.886 913.967 226.066V227.056C913.967 227.221 914.117 227.371 914.297 227.371H917.177C916.667 228.556 915.512 229.381 914.072 229.381C912.032 229.381 910.562 227.851 910.562 225.781C910.562 223.756 912.047 222.151 914.042 222.151C915.572 222.151 916.622 222.916 917.207 224.041C917.252 224.146 917.312 224.296 917.537 224.251L919.022 223.876C919.247 223.816 919.232 223.651 919.187 223.546C918.437 221.521 916.367 220.291 914.042 220.291Z",
    fill: "#1593B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.488 214.001H399C396.239 214.001 394 216.24 394 219.001V229.961C394 232.723 396.239 234.961 399 234.961H507.488C510.249 234.961 512.488 232.723 512.488 229.961V219.001C512.488 216.24 510.249 214.001 507.488 214.001Z",
    fill: "#0E64A9",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.021 231.712V228.472H414.271C416.746 228.472 418.021 226.882 418.021 225.007C418.021 223.132 416.746 221.542 414.271 221.542H410.326C410.146 221.542 410.011 221.692 410.011 221.857V231.712C410.011 231.892 410.146 232.042 410.326 232.042H411.706C411.886 232.042 412.021 231.892 412.021 231.712ZM412.021 226.702V223.312H414.136C415.141 223.312 415.936 223.957 415.936 225.007C415.936 226.057 415.141 226.702 414.136 226.702H412.021ZM425.379 231.757C425.454 231.937 425.529 232.042 425.709 232.042H427.284C427.524 232.042 427.689 231.862 427.569 231.562L423.774 221.857C423.684 221.632 423.504 221.542 423.354 221.542H421.494C421.344 221.542 421.164 221.632 421.074 221.857L417.294 231.577C417.189 231.862 417.324 232.042 417.549 232.042H419.034C419.199 232.042 419.304 231.922 419.364 231.757L420.219 229.492H424.509L425.379 231.757ZM420.849 227.797L422.349 223.807L423.864 227.797H420.849ZM433.067 232.252C435.347 232.252 437.387 231.052 438.077 228.997C438.122 228.862 438.137 228.727 437.912 228.667L436.412 228.292C436.187 228.247 436.127 228.397 436.082 228.502C435.542 229.597 434.537 230.392 433.082 230.392C431.087 230.392 429.647 228.817 429.647 226.792C429.647 224.767 431.087 223.192 433.082 223.192C434.537 223.192 435.542 223.987 436.082 225.082C436.127 225.187 436.187 225.337 436.412 225.292L437.912 224.917C438.137 224.857 438.122 224.722 438.077 224.587C437.387 222.532 435.347 221.332 433.067 221.332C429.977 221.332 427.547 223.702 427.547 226.792C427.547 229.882 429.977 232.252 433.067 232.252ZM448.01 221.977C448.16 221.797 448.07 221.542 447.83 221.542H446.285C446.015 221.542 445.85 221.632 445.7 221.827L442.565 225.817H441.245V221.857C441.245 221.692 441.095 221.542 440.915 221.542H439.55C439.37 221.542 439.235 221.692 439.235 221.857V231.712C439.235 231.892 439.37 232.042 439.55 232.042H440.915C441.095 232.042 441.245 231.892 441.245 231.712V227.587H442.58L445.67 231.787C445.82 231.997 445.955 232.042 446.21 232.042H447.89C448.055 232.042 448.19 231.862 448.04 231.652L444.23 226.552L448.01 221.977ZM456.038 231.757C456.113 231.937 456.188 232.042 456.368 232.042H457.943C458.183 232.042 458.348 231.862 458.228 231.562L454.433 221.857C454.343 221.632 454.163 221.542 454.013 221.542H452.153C452.003 221.542 451.823 221.632 451.733 221.857L447.953 231.577C447.848 231.862 447.983 232.042 448.208 232.042H449.693C449.858 232.042 449.963 231.922 450.023 231.757L450.878 229.492H455.168L456.038 231.757ZM451.508 227.797L453.008 223.807L454.523 227.797H451.508ZM463.786 221.332C460.651 221.332 458.206 223.702 458.206 226.792C458.206 229.882 460.486 232.252 463.546 232.252C465.271 232.252 466.366 231.562 467.041 230.632V231.712C467.041 231.892 467.191 232.042 467.371 232.042H468.556C468.736 232.042 468.886 231.892 468.886 231.712V227.107C468.886 226.927 468.736 226.792 468.556 226.792H464.041C463.861 226.792 463.711 226.927 463.711 227.107V228.097C463.711 228.262 463.861 228.412 464.041 228.412H466.921C466.411 229.597 465.256 230.422 463.816 230.422C461.776 230.422 460.306 228.892 460.306 226.822C460.306 224.797 461.791 223.192 463.786 223.192C465.316 223.192 466.366 223.957 466.951 225.082C466.996 225.187 467.056 225.337 467.281 225.292L468.766 224.917C468.991 224.857 468.976 224.692 468.931 224.587C468.181 222.562 466.111 221.332 463.786 221.332ZM472.175 232.042C472.355 232.042 472.49 231.892 472.49 231.712V221.857C472.49 221.692 472.355 221.542 472.175 221.542H470.795C470.615 221.542 470.48 221.692 470.48 221.857V231.712C470.48 231.892 470.615 232.042 470.795 232.042H472.175ZM480.916 231.727C481.051 231.952 481.246 232.042 481.561 232.042H483.046C483.211 232.042 483.376 231.907 483.376 231.727V221.857C483.376 221.692 483.211 221.542 483.046 221.542H481.666C481.501 221.542 481.366 221.692 481.366 221.857V228.697L476.971 221.797C476.851 221.602 476.686 221.542 476.506 221.542H474.721C474.541 221.542 474.406 221.692 474.406 221.857V231.727C474.406 231.907 474.541 232.042 474.721 232.042H476.101C476.281 232.042 476.416 231.907 476.416 231.727V224.722L480.916 231.727ZM490.314 221.332C487.179 221.332 484.734 223.702 484.734 226.792C484.734 229.882 487.014 232.252 490.074 232.252C491.799 232.252 492.894 231.562 493.569 230.632V231.712C493.569 231.892 493.719 232.042 493.899 232.042H495.084C495.264 232.042 495.414 231.892 495.414 231.712V227.107C495.414 226.927 495.264 226.792 495.084 226.792H490.569C490.389 226.792 490.239 226.927 490.239 227.107V228.097C490.239 228.262 490.389 228.412 490.569 228.412H493.449C492.939 229.597 491.784 230.422 490.344 230.422C488.304 230.422 486.834 228.892 486.834 226.822C486.834 224.797 488.319 223.192 490.314 223.192C491.844 223.192 492.894 223.957 493.479 225.082C493.524 225.187 493.584 225.337 493.809 225.292L495.294 224.917C495.519 224.857 495.504 224.692 495.459 224.587C494.709 222.562 492.639 221.332 490.314 221.332Z",
    fill: "#1593B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 390.001L20 524.001C20 526.762 22.2386 529.001 25 529.001H36C38.7614 529.001 41 526.762 41 524.001L41 390.001C41 387.24 38.7614 385.001 36 385.001H25C22.2386 385.001 20 387.24 20 390.001Z",
    fill: "#0E64A9",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.041 523.191C36.041 523.011 35.891 522.876 35.711 522.876H25.8561C25.6911 522.876 25.5411 523.011 25.5411 523.191V524.571C25.5411 524.751 25.6911 524.886 25.8561 524.886H35.711C35.891 524.886 36.041 524.751 36.041 524.571V523.191ZM35.726 514.45C35.951 514.315 36.041 514.12 36.041 513.805V512.32C36.041 512.155 35.906 511.99 35.726 511.99H25.8561C25.6911 511.99 25.5411 512.155 25.5411 512.32V513.7C25.5411 513.865 25.6911 514 25.8561 514H32.696L25.7961 518.395C25.6011 518.515 25.5411 518.68 25.5411 518.86V520.645C25.5411 520.825 25.6911 520.96 25.8561 520.96H35.726C35.906 520.96 36.041 520.825 36.041 520.645V519.265C36.041 519.085 35.906 518.95 35.726 518.95H28.7211L35.726 514.45ZM25.3311 506.461C25.3311 508.771 26.6361 510.466 28.4811 510.466C29.9361 510.466 30.911 509.551 31.331 507.916L31.826 506.011C32.096 504.976 32.471 504.436 33.191 504.436C33.836 504.436 34.466 505.066 34.466 506.326C34.466 507.586 33.896 508.396 33.311 508.996C33.101 509.206 32.981 509.416 33.206 509.701L33.851 510.526C34.076 510.811 34.421 510.751 34.676 510.526C35.441 509.851 36.251 508.501 36.251 506.446C36.251 503.596 34.586 502.246 32.996 502.246C31.331 502.246 30.461 503.356 30.011 505.051L29.4711 507.106C29.2311 508.036 28.8261 508.306 28.3461 508.306C27.5511 508.306 27.1011 507.511 27.1011 506.521C27.1011 505.621 27.4911 504.886 28.0161 504.196C28.2561 503.881 28.2261 503.611 28.0161 503.401L27.3561 502.771C27.2061 502.621 26.9511 502.471 26.6061 502.831C25.9461 503.521 25.3311 504.811 25.3311 506.461ZM35.711 498.94H32.471V496.69C32.471 494.215 30.881 492.94 29.0061 492.94C27.1311 492.94 25.5411 494.215 25.5411 496.69V500.635C25.5411 500.815 25.6911 500.95 25.8561 500.95H35.711C35.891 500.95 36.041 500.815 36.041 500.635V499.255C36.041 499.075 35.891 498.94 35.711 498.94ZM30.701 498.94H27.3111V496.825C27.3111 495.82 27.9561 495.025 29.0061 495.025C30.056 495.025 30.701 495.82 30.701 496.825V498.94ZM25.5411 491.436C25.5411 491.616 25.6911 491.751 25.8561 491.751H35.711C35.891 491.751 36.041 491.616 36.041 491.436V483.951C36.041 483.771 35.891 483.621 35.711 483.621H34.511C34.331 483.621 34.196 483.771 34.196 483.951V489.741H31.661V486.771C31.661 486.591 31.511 486.456 31.331 486.456H30.191C30.011 486.456 29.8611 486.591 29.8611 486.771V489.741H27.3861V484.041C27.3861 483.861 27.2511 483.726 27.0711 483.726H25.8711C25.6911 483.726 25.5411 483.861 25.5411 484.041V491.436ZM36.251 477.689C36.251 475.409 35.051 473.369 32.996 472.679C32.861 472.634 32.726 472.619 32.666 472.844L32.291 474.344C32.246 474.569 32.396 474.629 32.501 474.674C33.596 475.214 34.391 476.219 34.391 477.674C34.391 479.669 32.816 481.109 30.791 481.109C28.7661 481.109 27.1911 479.669 27.1911 477.674C27.1911 476.219 27.9861 475.214 29.0811 474.674C29.1861 474.629 29.3361 474.569 29.2911 474.344L28.9161 472.844C28.8561 472.619 28.7211 472.634 28.5861 472.679C26.5311 473.369 25.3311 475.409 25.3311 477.689C25.3311 480.779 27.7011 483.209 30.791 483.209C33.881 483.209 36.251 480.779 36.251 477.689ZM27.0711 472.536C27.2511 472.536 27.3861 472.401 27.3861 472.221V469.101H35.711C35.891 469.101 36.041 468.966 36.041 468.786V467.361C36.041 467.181 35.891 467.031 35.711 467.031H27.3861V463.911C27.3861 463.731 27.2511 463.596 27.0711 463.596H25.8711C25.6911 463.596 25.5411 463.731 25.5411 463.911V472.221C25.5411 472.401 25.6911 472.536 25.8711 472.536H27.0711ZM36.041 460.774C36.041 460.594 35.891 460.459 35.711 460.459H25.8561C25.6911 460.459 25.5411 460.594 25.5411 460.774V462.154C25.5411 462.334 25.6911 462.469 25.8561 462.469H35.711C35.891 462.469 36.041 462.334 36.041 462.154V460.774ZM30.791 448.058C27.7011 448.058 25.3311 450.488 25.3311 453.578C25.3311 456.653 27.7011 459.098 30.791 459.098C33.881 459.098 36.251 456.653 36.251 453.578C36.251 450.488 33.881 448.058 30.791 448.058ZM30.791 450.143C32.816 450.143 34.391 451.583 34.391 453.578C34.391 455.573 32.816 456.998 30.791 456.998C28.7661 456.998 27.1911 455.573 27.1911 453.578C27.1911 451.583 28.7661 450.143 30.791 450.143ZM35.726 440.182C35.951 440.047 36.041 439.852 36.041 439.537V438.052C36.041 437.887 35.906 437.722 35.726 437.722H25.8561C25.6911 437.722 25.5411 437.887 25.5411 438.052V439.432C25.5411 439.597 25.6911 439.732 25.8561 439.732H32.696L25.7961 444.127C25.6011 444.247 25.5411 444.412 25.5411 444.592V446.377C25.5411 446.557 25.6911 446.692 25.8561 446.692H35.726C35.906 446.692 36.041 446.557 36.041 446.377V444.997C36.041 444.817 35.906 444.682 35.726 444.682H28.7211L35.726 440.182ZM35.756 425.933C35.936 425.858 36.041 425.783 36.041 425.603V424.028C36.041 423.788 35.861 423.623 35.561 423.743L25.8561 427.538C25.6311 427.628 25.5411 427.808 25.5411 427.958V429.818C25.5411 429.968 25.6311 430.148 25.8561 430.238L35.576 434.018C35.861 434.123 36.041 433.988 36.041 433.763V432.278C36.041 432.113 35.921 432.008 35.756 431.948L33.491 431.093V426.803L35.756 425.933ZM31.796 430.463L27.8061 428.963L31.796 427.448V430.463ZM36.041 414.205C36.041 413.965 35.801 413.86 35.621 413.98L31.676 416.425C31.151 414.745 29.6811 414.25 28.7061 414.25C26.9061 414.25 25.5411 415.66 25.5411 417.88V422.5C25.5411 422.71 25.7061 422.815 25.8561 422.815H35.711C35.891 422.815 36.041 422.68 36.041 422.5V421.12C36.041 420.94 35.891 420.805 35.711 420.805H32.021V418.48L35.711 416.26C35.951 416.125 36.041 415.99 36.041 415.735V414.205ZM30.386 418.105V420.805H27.3111V418.075C27.3111 417.07 27.8961 416.365 28.8111 416.365C29.7411 416.365 30.386 417.07 30.386 418.105ZM25.5411 412.378C25.5411 412.558 25.6911 412.693 25.8561 412.693H35.711C35.891 412.693 36.041 412.558 36.041 412.378V404.893C36.041 404.713 35.891 404.563 35.711 404.563H34.511C34.331 404.563 34.196 404.713 34.196 404.893V410.683H31.661V407.713C31.661 407.533 31.511 407.398 31.331 407.398H30.191C30.011 407.398 29.8611 407.533 29.8611 407.713V410.683H27.3861V404.983C27.3861 404.803 27.2511 404.668 27.0711 404.668H25.8711C25.6911 404.668 25.5411 404.803 25.5411 404.983V412.378ZM35.756 396.314C35.936 396.239 36.041 396.164 36.041 395.984V394.409C36.041 394.169 35.861 394.004 35.561 394.124L25.8561 397.919C25.6311 398.009 25.5411 398.189 25.5411 398.339V400.199C25.5411 400.349 25.6311 400.529 25.8561 400.619L35.576 404.399C35.861 404.504 36.041 404.369 36.041 404.144V402.659C36.041 402.494 35.921 402.389 35.756 402.329L33.491 401.474V397.184L35.756 396.314ZM31.796 400.844L27.8061 399.344L31.796 397.829V400.844Z",
    fill: "#1593B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 304.212H1034V325.212H1044V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 361.212H1034V381.212H1044V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099 304.212H1089V325.212H1099V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099 361.212H1089V381.212H1099V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 304.212H1145V325.212H1155V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 361.212H1145V381.212H1155V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 304.212H1201V325.212H1210V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210 361.212H1201V381.212H1210V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 304.212H1070V325.212H1080V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 361.212H1070V381.212H1080V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136 304.212H1126V325.212H1136V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136 361.212H1126V381.212H1136V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 304.212H1182V325.212H1191V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 361.212H1182V381.212H1191V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 304.212H1237V325.212H1247V304.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 361.212H1237V381.212H1247V361.212Z",
    stroke: "#4D6994",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 293.212H1039V287.717V282.212H1080V287.717V293.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 350.212H1039V344.217V338.212H1080V344.217V350.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136 293.212H1094V287.717V282.212H1136V287.717V293.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136 350.212H1094V344.217V338.212H1136V344.217V350.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 293.212H1150V287.717V282.212H1191V287.717V293.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 350.212H1150V344.217V338.212H1191V344.217V350.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 293.212H1206V287.717V282.212H1247V287.717V293.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247 350.212H1206V344.217V338.212H1247V344.217V350.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 288.212H1080",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 344.212H1080",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 288.212H1136",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095 344.212H1136",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151 288.212H1191",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151 344.212H1191",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 288.212H1247",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206 344.212H1247",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 298.212H1048V331.212H1066V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 355.212H1048V387.212H1066V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 298.212H1104V331.212H1122V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 355.212H1104V387.212H1122V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 298.212H1159V331.212H1177V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 355.212H1159V387.212H1177V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 298.212H1215V331.212H1233V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 355.212H1215V387.212H1233V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 298.212H1057V331.212H1066V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066 355.212H1057V387.212H1066V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 298.212H1113V331.212H1122V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 355.212H1113V387.212H1122V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 298.212H1168V331.212H1177V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177 355.212H1168V387.212H1177V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 298.212H1224V331.212H1233V298.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233 355.212H1224V387.212H1233V355.212Z",
    stroke: "#4D6994",
    strokeWidth: 1.4142,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 99.1995H41.88V96.7176H36.0987V94.8831H41.248V92.6166H36.0987V91.1058H41.88V88.84H33V99.1995Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.994 88.84L139.375 94.8831L137.649 88.84H135.444L133.825 94.8831L132.207 88.84H129.2L132.207 99.1995H134.981L136.6 93.1563L138.219 99.1995H140.994L144 88.84H140.994Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2811 131.976C107.141 131.976 124.052 115.065 124.052 94.2049C124.052 73.3448 107.141 56.4343 86.2811 56.4343C65.421 56.4343 48.5105 73.3448 48.5105 94.2049C48.5105 115.065 65.421 131.976 86.2811 131.976Z",
    fill: "#BFD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9082 44.4089L88.7951 50.3603H91.4622V40H88.5486V45.7353L83.9082 40H81.1023V50.3603H83.9082V44.4089Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8552 141.873C86.0206 141.379 86.0203 141.379 86.0203 141.379C85.7582 141.379 85.4965 141.133 85.2344 141.133C85.2344 140.886 84.9721 140.886 84.9721 140.639C84.9721 140.392 85.2343 140.146 85.4964 139.899C85.7585 139.652 86.0204 139.653 86.5446 139.653C86.8067 139.653 87.3307 139.652 87.5928 139.899C87.8549 140.146 87.855 140.392 88.1171 140.639C90.7225 140.146 90.7224 140.146 90.7224 140.146C90.4604 139.406 89.9362 138.666 89.1499 138.173C88.6258 137.926 87.5775 137.679 86.5446 137.679C85.2342 137.679 84.2012 137.926 83.415 138.419C82.6288 139.159 82.3668 139.899 82.3668 140.886C82.3668 141.626 82.6289 142.366 83.153 142.86C83.6772 143.106 84.2013 143.353 84.9875 143.6C87.0842 144.093 87.0843 144.093 87.0843 144.093C87.3464 144.093 87.6085 144.34 87.8706 144.34C87.8706 144.586 88.1326 144.586 88.1326 144.833C88.1326 145.079 87.8703 145.326 87.6083 145.573C87.3462 145.819 86.8221 145.82 86.56 145.82C86.0359 145.82 85.7736 145.819 85.2495 145.573C84.9874 145.326 84.7256 145.079 84.7256 144.833C81.8581 145.326 81.8579 145.326 81.8579 145.326C82.3821 146.312 82.9065 146.806 83.6928 147.299C84.479 147.793 85.265 148.039 86.56 148.039C87.6084 148.039 88.6569 147.793 89.4277 147.053C90.476 146.559 90.7379 145.819 90.7379 144.833C90.7379 143.846 90.4758 143.353 89.9516 142.86C89.6895 142.366 88.9035 142.119 87.8552 141.873Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.083 82.997C103.503 85.8645 104.845 89.2559 105.122 93.1563C93.02 93.1563 93.0198 93.1563 93.0198 93.1563L101.083 82.997ZM87.3621 98.9066C89.7825 97.0875 89.7826 97.0872 89.7826 97.0872C87.9018 95.268 87.9018 95.2685 87.9018 95.2685C88.1639 95.2685 88.1638 95.2685 88.1638 95.2685C90.0446 96.8256 90.0446 96.8252 90.0446 96.8252C91.3858 95.2682 91.386 95.2685 91.386 95.2685C105.107 95.2685 105.107 95.2685 105.107 95.2685C104.567 104.657 97.0283 112.211 87.3467 112.736V98.9066H87.3621ZM85.2194 100.201C85.2194 112.72 85.2194 112.72 85.2194 112.72C80.9181 112.458 77.141 110.901 73.9189 108.295L85.2194 100.201ZM72.0227 106.461C69.3248 103.331 67.444 99.4152 67.444 95.2527C80.9027 95.2527 80.9026 95.2527 80.9026 95.2527L72.0227 106.461ZM85.2194 90.566C84.1402 91.3523 84.1399 91.3526 84.1399 91.3526C85.2191 92.401 85.2194 92.4005 85.2194 92.4005C85.2194 92.6626 85.2194 92.6632 85.2194 92.6632C84.1402 91.3528 84.1399 91.3526 84.1399 91.3526C82.5212 93.1718 82.5215 93.1713 82.5215 93.1713C67.4595 93.1713 67.4594 93.1713 67.4594 93.1713C67.7215 83.7826 75.5378 76.229 85.2194 75.9669V90.566ZM87.3621 88.9935C87.3621 75.9665 87.3621 75.9669 87.3621 75.9669C91.9408 75.9669 95.9798 77.7862 99.2019 80.6536L87.3621 88.9935ZM107.543 95.2527C109.963 95.2527 109.963 95.2527 109.963 95.2527C109.963 93.1715 109.963 93.1713 109.963 93.1713C107.542 93.1713 107.543 93.1713 107.543 93.1713C107.543 88.7468 105.662 84.3072 102.702 80.9156C108.359 74.1323 108.36 74.1325 108.36 74.1325C101.098 79.3433 101.098 79.3431 101.098 79.3431C97.5986 75.9514 92.7579 73.6079 87.3775 73.3458C87.3775 71.2646 87.3775 71.2644 87.3775 71.2644C85.2192 71.2644 85.2194 71.2644 85.2194 71.2644C85.2194 73.3457 85.2194 73.3458 85.2194 73.3458C74.1811 73.87 65.301 82.4726 65.0389 93.1563C62.6185 93.1563 62.6184 93.1563 62.6184 93.1563C62.6184 95.2375 62.6184 95.2377 62.6184 95.2377C65.0388 95.2377 65.0389 95.2377 65.0389 95.2377C65.0389 100.186 67.1972 104.888 70.4193 108.264C65.8406 113.999 65.8406 114 65.8406 114C72.0227 109.575 72.0227 109.575 72.0227 109.575C75.5222 112.704 80.101 114.786 85.2039 115.048C85.2039 117.129 85.2039 117.129 85.2039 117.129C87.3622 117.129 87.3621 117.129 87.3621 117.129C87.3621 115.048 87.3621 115.048 87.3621 115.048C98.4003 114.539 107.003 105.936 107.543 95.2527Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1234 93.4649H56.6836V94.9448H61.1234V93.4649Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.882 93.4649H111.443V94.9448H115.882V93.4649Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7639 118.625H84.804V123.064H87.7639V118.625Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7639 65.3447H84.804V69.7845H87.7639V65.3447Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1234 93.4649H56.6836V94.9448H61.1234V93.4649Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.882 93.4649H111.443V94.9448H115.882V93.4649Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7639 118.625H84.804V123.064H87.7639V118.625Z",
    fill: "#005AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7639 65.3447H84.804V69.7845H87.7639V65.3447Z",
    fill: "#005AAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1339,
    height: 760,
    fill: "white",
    transform: "translate(20 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloormapMain);
export default __webpack_public_path__ + "static/media/floormap-main.840c95c95c384ee000b324cd4e36203a.svg";
export { ForwardRef as ReactComponent };